// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   Input,
//   ListGroup,
//   ListGroupItem,
//   CardHeader,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Form,
//   FormGroup,
//   Nav,
//   NavItem,
//   NavLink,
// } from "reactstrap";
// import Swal from "sweetalert2";
// import Header from "components/Headers/Header";
// import { useSessionStore } from "../../stores/sessionStore";
// import { useSettingStore } from "../../stores/settingStore";
// import { api } from "../../config/middleware";
// import {
//   API_GETSERVICEWITHPRODUCTS,
//   API_GETSERVICEPACKAGES,
//   API_BUYSERVICEPACKAGE,
//   API_GETCUSTOMERWITHPACKAGE,
//   API_CREATEBILL,
//   API_ADDCUSTOMER,
//   API_GETSETTING,
// } from "../../config/api";

// const AddDetailFab = ({ onClick }) => {
//   return (
//     <button
//       type="button"
//       className="add-detail-fab"
//       onClick={onClick}
//       title="เพิ่มรายการ"
//     >
//       <i className="ni ni-fat-add" />
//     </button>
//   );
// };

// const Order = () => {
//   const sa = {
//     info: (text, title = "แจ้งเตือน") =>
//       Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
//     success: (text, title = "สำเร็จ") =>
//       Swal.fire({ icon: "success", title, text, confirmButtonText: "ตกลง" }),
//     error: (text, title = "เกิดข้อผิดพลาด") =>
//       Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
//   };

//   const orgId = useSessionStore((s) => s.profile?.orgId);
//   const tnId = useSessionStore((s) => s.profile?.tnId);
//   const brId = useSessionStore((s) => s.profile?.brId);

//   const setBillMode = useSettingStore((s) => s.setBillMode);

//   useEffect(() => {
//     const fetchSetting = async () => {
//       const res = await api.get(API_GETSETTING, {
//         params: { TNID: tnId, ORGID: orgId, BRID: brId },
//       });

//       if (res.data?.statustext === "SUCCESS") {
//         setBillMode(res.data.data.billMode);
//       }
//     };

//     if (tnId != null && orgId != null && brId != null) {
//       fetchSetting();
//     }
//   }, [tnId, orgId, brId]);

//   // ---------- Tabs ----------
//   const [activeTab, setActiveTab] = useState("laundry"); // "laundry" | "package"

//   // ---------- Sub-mode (เฉพาะแท็บเปิดบิล) ----------
//   const [laundryMode, setLaundryMode] = useState("perItem"); // 'perItem' | 'package' | 'byWeight'

//   // ---------- Search / Customer ----------
//   const buildCustomerQuery = (term) => {
//     const t = String(term || "").trim();
//     if (!t) return null;
//     if (/^CUS/i.test(t)) return { CMCODE: t }; // รหัสลูกค้า
//     if (/^[0-9]+$/.test(t)) return { CMMOBILE: t }; // เบอร์โทร
//     return { CMNAME: t }; // ชื่อ
//   };

//   const [selectedCustomerLaundry, setSelectedCustomerLaundry] = useState(null); // ใช้กับแท็บ "เปิดบิล"
//   const [selectedCustomerPackage, setSelectedCustomerPackage] = useState(null); // ใช้กับแท็บ "ซื้อแพ็คเกจ"
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [isPkgModalOpen, setIsPkgModalOpen] = useState(false);

//   const [customerType, setCustomerType] = useState("individual"); // "individual" | "juristic"

//   const [submittingCustomer, setSubmittingCustomer] = useState(false);

//   const [customerForm, setCustomerForm] = useState({
//     cmName: "",
//     cmMobile: "",
//   });

//   const handleChangeCustomerForm = (e) => {
//     const { name, value } = e.target;
//     setCustomerForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const appendStr = (fd, key, val) => {
//     if (val === undefined || val === null) return;
//     fd.append(key, String(val));
//   };

//   const isCompany = customerType === "juristic";

//   const handleAddCustomer = () => setIsAddModalOpen(true);
//   const toggleAddModal = () => setIsAddModalOpen((v) => !v);
//   const togglePkgModal = () => setIsPkgModalOpen((v) => !v);

//   const pickCustomerLaundry = (cus) => {
//     setSelectedCustomerLaundry(cus);
//     setSelectedCustomerPackageInfo(null);
//     // reset สภาพเดิม เพื่อไม่ให้เหลือ state ของลูกค้าคนก่อน
//     setLockServiceUI(false);
//     restoreServiceProducts(); // คืนรายการบริการจาก originalServicesRef และเคลียร์ qty

//     const subs = Array.isArray(cus.subscriptions) ? cus.subscriptions : [];

//     if (subs.length > 0) {
//       setIsPkgModalOpen(true);
//     } else {
//       setIsPkgModalOpen(false);
//     }
//   };

//   const pickCustomerPackage = (cus) => {
//     setSelectedCustomerPackage(cus);
//   };

//   const SearchBoxBase = ({ className, inputId, onPick }) => {
//     const inputRef = useRef(null);
//     const composingRef = useRef(false);
//     const debounceRef = useRef(null);
//     const reqCounter = useRef(0);

//     const [isSearching, setIsSearching] = useState(false);
//     const [cusErr, setCusErr] = useState("");
//     const [searchResults, setSearchResults] = useState([]);

//     const fireSearch = async (raw) => {
//       const term = String(raw || "").trim();
//       setCusErr("");
//       if (!orgId || !term) {
//         setSearchResults([]);
//         setIsSearching(false);
//         return;
//       }
//       const q = buildCustomerQuery(term);
//       if (!q) {
//         setSearchResults([]);
//         setIsSearching(false);
//         return;
//       }
//       const myReq = ++reqCounter.current;
//       setIsSearching(true);
//       try {
//         const res = await api.post(API_GETCUSTOMERWITHPACKAGE, {
//           ORGID: orgId,
//           ...q,
//         });
//         if (myReq !== reqCounter.current) return;
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         const rows = arr.map((r) => ({
//           id: r.cmCode || r.id,
//           code: r.cmCode || "",
//           name: r.cmName || "",
//           mobile: r.cmMobile || "",
//           phone: r.cmPhone || "",
//           subscriptions: r.subscriptions || [],
//           products: r.products || [],
//           raw: r,
//         }));
//         setSearchResults(rows.slice(0, 10));
//       } catch (e) {
//         if (myReq !== reqCounter.current) return;
//         setSearchResults([]);
//         setCusErr(e?.response?.data?.message || e?.message || "ค้นหาไม่สำเร็จ");
//       } finally {
//         if (reqCounter.current === myReq) setIsSearching(false);
//       }
//     };

//     const onChange = (e) => {
//       const v = e.target.value ?? "";
//       if (debounceRef.current) clearTimeout(debounceRef.current);
//       debounceRef.current = setTimeout(() => fireSearch(v), 350);
//     };

//     return (
//       <div
//         className={className}
//         style={{ position: "relative", width: "100%" }}
//       >
//         <div className="input-group w-100">
//           <input
//             id={inputId}
//             ref={inputRef}
//             type="text"
//             className="form-control"
//             placeholder="รหัสลูกค้า/ชื่อ/เบอร์โทร"
//             autoComplete="off"
//             spellCheck={false}
//             onChange={onChange}
//             onCompositionStart={() => (composingRef.current = true)}
//             onCompositionEnd={(e) => {
//               composingRef.current = false;
//               fireSearch(e.target.value);
//             }}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") e.preventDefault();
//             }}
//           />
//           <div className="input-group-append">
//             <button
//               type="button"
//               onClick={() => setIsAddModalOpen(true)}
//               className="btn"
//               style={{
//                 backgroundColor: "#0ea5e9",
//                 color: "#fff",
//                 border: "none",
//               }}
//               title="เพิ่มลูกค้าใหม่"
//             >
//               <i className="ni ni-fat-add" />
//             </button>
//           </div>
//         </div>

//         {isSearching && (
//           <div
//             className="shadow"
//             style={{
//               position: "absolute",
//               zIndex: 20,
//               top: "100%",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               borderRadius: 12,
//               border: "1px solid #e5e7eb",
//               marginTop: 6,
//               padding: "10px 12px",
//             }}
//           >
//             กำลังค้นหา…
//           </div>
//         )}

//         {!isSearching && cusErr && (
//           <div
//             className="shadow text-danger"
//             style={{
//               position: "absolute",
//               zIndex: 20,
//               top: "100%",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               borderRadius: 12,
//               border: "1px solid #e5e7eb",
//               marginTop: 6,
//               padding: "10px 12px",
//             }}
//           >
//             {cusErr}
//           </div>
//         )}

//         {searchResults.length > 0 && !isSearching && (
//           <div
//             className="shadow"
//             style={{
//               position: "absolute",
//               zIndex: 20,
//               top: "100%",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               borderRadius: 12,
//               border: "1px solid #e5e7eb",
//               marginTop: 6,
//               overflow: "hidden",
//             }}
//           >
//             {searchResults.map((c) => (
//               <div
//                 key={c.id}
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   onPick(c);
//                 }}
//                 style={{
//                   padding: "12px 14px",
//                   cursor: "pointer",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <div style={{ fontWeight: 700 }}>
//                   {c.code ? `${c.code} - ` : ""}
//                   {c.name}
//                 </div>
//                 <div style={{ fontSize: 12, color: "#64748b" }}>
//                   {c.mobile || c.phone || ""}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const SearchBoxLaundry = (props) => (
//     <SearchBoxBase {...props} onPick={pickCustomerLaundry} />
//   );
//   const SearchBoxPackage = (props) => (
//     <SearchBoxBase {...props} onPick={pickCustomerPackage} />
//   );

//   // ===================================================================
//   // L A U N D R Y
//   // ===================================================================
//   const [laundryServices, setLaundryServices] = useState([]);
//   const [selectedServiceId, setSelectedServiceId] = useState(null);
//   const [laundryLoading, setLaundryLoading] = useState(false);
//   const [laundryError, setLaundryError] = useState("");

//   // เก็บ services ดิบไว้สำหรับ restore
//   const originalServicesRef = useRef([]);

//   // ซ่อนแถบปุ่มบริการเมื่อเลือกแพ็คเกจจากโมดัล
//   const [lockServiceUI, setLockServiceUI] = useState(false);

//   // แพ็คเกจลูกค้าที่เลือก (จาก modal)
//   const [selectedCustomerPackageInfo, setSelectedCustomerPackageInfo] =
//     useState(null);

//   // Custom items (กรอกเอง)
//   const [customItems, setCustomItems] = useState([]);
//   const addCustomItem = () => {
//     setCustomItems((prev) => [
//       ...prev,
//       {
//         id: `custom-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
//         name: "",
//         price: 0,
//         qty: 0,
//       },
//     ]);
//   };
//   const updateCustomName = (id, value) =>
//     setCustomItems((prev) =>
//       prev.map((it) => (it.id === id ? { ...it, name: value } : it)),
//     );
//   const updateCustomPrice = (id, value) => {
//     const num = value === "" ? "" : Math.max(0, Number(value));
//     setCustomItems((prev) =>
//       prev.map((it) => (it.id === id ? { ...it, price: num } : it)),
//     );
//   };
//   const updateCustomQty = (id, value) => {
//     const num = value === "" ? "" : Math.max(0, Number(value));
//     setCustomItems((prev) =>
//       prev.map((it) => (it.id === id ? { ...it, qty: num } : it)),
//     );
//   };
//   const incCustomQty = (id) =>
//     setCustomItems((prev) =>
//       prev.map((it) =>
//         it.id === id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
//       ),
//     );
//   const decCustomQty = (id) =>
//     setCustomItems((prev) =>
//       prev.map((it) =>
//         it.id === id
//           ? { ...it, qty: Math.max(0, Number(it.qty || 0) - 1) }
//           : it,
//       ),
//     );

//   useEffect(() => {
//     const fetchServices = async () => {
//       if (activeTab !== "laundry" || !orgId) return;
//       setLaundryLoading(true);
//       setLaundryError("");
//       try {
//         const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         const normalized = arr.map((s) => ({
//           id: s.svId,
//           name: s.svName,
//           type: s.svType,
//           unit: s.svUnit || "ตัว/ชิ้น",
//           products: (s.products || []).map((p) => ({
//             id: p.pdId,
//             name: p.pdName,
//             price: Number(p.pdPrice ?? 0),
//             qty: 0,
//           })),
//         }));
//         setLaundryServices(normalized);
//         originalServicesRef.current = normalized; // เก็บต้นฉบับไว้
//         setSelectedServiceId(normalized[0]?.id ?? null);
//       } catch (e) {
//         setLaundryError(e?.message || "โหลดข้อมูลบริการไม่สำเร็จ");
//       } finally {
//         setLaundryLoading(false);
//       }
//     };
//     fetchServices();
//   }, [activeTab, orgId]);

//   const displayLaundryServices = useMemo(() => {
//     const t = (x) =>
//       String(x?.type || "")
//         .toLowerCase()
//         .trim();
//     switch (laundryMode) {
//       case "byWeight":
//         return laundryServices.filter(
//           (s) => t(s).includes("กิโล") || t(s).includes("ชั่ง"),
//         );
//       case "package":
//         return laundryServices.filter((s) => t(s).includes("แพ็คเกจ"));
//       default:
//         return laundryServices.filter((s) => {
//           const tt = t(s);
//           if (!tt) return true;
//           return (
//             tt.includes("รายชิ้น") &&
//             !tt.includes("แพ็คเกจ") &&
//             !tt.includes("กิโล") &&
//             !tt.includes("ชั่ง")
//           );
//         });
//     }
//   }, [laundryServices, laundryMode]);

//   useEffect(() => {
//     if (activeTab !== "laundry") return;
//     if (!displayLaundryServices.find((s) => s.id === selectedServiceId)) {
//       setSelectedServiceId(displayLaundryServices[0]?.id ?? null);
//     }
//   }, [activeTab, displayLaundryServices, selectedServiceId]);

//   const selectedService = useMemo(
//     () => laundryServices.find((s) => s.id === selectedServiceId) || null,
//     [laundryServices, selectedServiceId],
//   );

//   // ชื่อแพ็คเกจ/บริการที่เลือกปัจจุบัน
//   const currentPackageName = useMemo(() => {
//     if (selectedCustomerPackageInfo?.name)
//       return selectedCustomerPackageInfo.name; // มาจาก modal
//     if (selectedService?.name) return selectedService.name; // เลือกจากปุ่ม รายชิ้น/แพ็คเกจ/ชั่งกิโล
//     return "";
//   }, [selectedCustomerPackageInfo, selectedService]);

//   const updateQtyLaundry = (pdId, value) => {
//     const num = value === "" ? "" : Math.max(0, Number(value));
//     setLaundryServices((prev) =>
//       prev.map((svc) =>
//         svc.id !== selectedServiceId
//           ? svc
//           : {
//               ...svc,
//               products: svc.products.map((p) =>
//                 p.id === pdId ? { ...p, qty: num } : p,
//               ),
//             },
//       ),
//     );
//   };
//   const incQtyLaundry = (pdId) =>
//     setLaundryServices((prev) =>
//       prev.map((svc) =>
//         svc.id !== selectedServiceId
//           ? svc
//           : {
//               ...svc,
//               products: svc.products.map((p) =>
//                 p.id === pdId ? { ...p, qty: Number(p.qty || 0) + 1 } : p,
//               ),
//             },
//       ),
//     );
//   const decQtyLaundry = (pdId) =>
//     setLaundryServices((prev) =>
//       prev.map((svc) =>
//         svc.id !== selectedServiceId
//           ? svc
//           : {
//               ...svc,
//               products: svc.products.map((p) =>
//                 p.id === pdId
//                   ? { ...p, qty: Math.max(0, Number(p.qty || 0) - 1) }
//                   : p,
//               ),
//             },
//       ),
//     );

//   const cartLaundry = useMemo(() => {
//     const items = [];
//     laundryServices.forEach((svc) =>
//       svc.products.forEach((p) => {
//         if (Number(p.qty) > 0) {
//           items.push({
//             id: `${svc.id}:${p.id}`,
//             name: `${p.name}`,
//             price: p.price,
//             qty: Number(p.qty),
//           });
//         }
//       }),
//     );
//     customItems.forEach((c) => {
//       if (Number(c.qty) > 0) {
//         items.push({
//           id: c.id,
//           name: c.name || "รายการ (กรอกเอง)",
//           price: Number(c.price || 0),
//           qty: Number(c.qty),
//         });
//       }
//     });
//     return items;
//   }, [laundryServices, customItems]);

//   const totalLaundry = useMemo(
//     () => cartLaundry.reduce((s, p) => s + p.price * p.qty, 0),
//     [cartLaundry],
//   );

//   const handleSelectService = (id) => {
//     if (id === selectedServiceId) return;
//     // reset qty ทุก service เพื่อไม่ให้ปนกัน
//     setLaundryServices((prev) =>
//       prev.map((svc) => ({
//         ...svc,
//         products: svc.products.map((p) => ({ ...p, qty: 0 })),
//       })),
//     );
//     setSelectedServiceId(id);
//   };

//   const productsAll = selectedService?.products || [];

//   const listRef = useRef(null);

//   useEffect(() => {
//     if (listRef.current) listRef.current.scrollTop = 0;
//   }, [selectedServiceId, laundryMode, lockServiceUI]);

//   // ===================================================================
//   // P A C K A G E
//   // ===================================================================
//   const [servicePkgs, setServicePkgs] = useState([]);
//   const [cartPackage, setCartPackage] = useState([]);
//   const [spLoading, setSpLoading] = useState(false);
//   const [spError, setSpError] = useState("");
//   const [paying, setPaying] = useState(false);
//   const [payResult, setPayResult] = useState(null);

//   const syncCartPackage = (rows) =>
//     setCartPackage(
//       rows
//         .filter((p) => Number(p.qty) > 0)
//         .map((p) => ({
//           id: p.id,
//           name: p.name,
//           price: p.price,
//           qty: Number(p.qty),
//         })),
//     );

//   const updateQtyPkg = (id, value) => {
//     const num = value === "" ? "" : Math.max(0, Number(value));
//     setServicePkgs((prev) => {
//       const next = prev.map((it) => (it.id === id ? { ...it, qty: num } : it));
//       syncCartPackage(next);
//       return next;
//     });
//   };
//   const incQtyPkg = (id) =>
//     setServicePkgs((prev) => {
//       const next = prev.map((it) =>
//         it.id === id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
//       );
//       syncCartPackage(next);
//       return next;
//     });
//   const decQtyPkg = (id) =>
//     setServicePkgs((prev) => {
//       const next = prev.map((it) =>
//         it.id === id
//           ? { ...it, qty: Math.max(0, Number(it.qty || 0) - 1) }
//           : it,
//       );
//       syncCartPackage(next);
//       return next;
//     });

//   const totalPackage = useMemo(
//     () => cartPackage.reduce((s, p) => s + p.price * p.qty, 0),
//     [cartPackage],
//   );

//   useEffect(() => {
//     const fetchPkgs = async () => {
//       if (activeTab !== "package" || !orgId) return;
//       setSpLoading(true);
//       setSpError("");
//       try {
//         const res = await api.get(API_GETSERVICEPACKAGES, {
//           params: { ORGID: orgId },
//         });
//         const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
//         const normalized = arr.map((x) => ({
//           id: x.svId,
//           code: x.svCode,
//           name: x.svName,
//           price: Number(x.svPrice ?? 0),
//           unit: x.svUnit || "ครั้ง",
//           qty: x.svQty,
//           leadtime: Number(x.svLeadTime ?? 0),
//           type: x.svType,
//         }));
//         setServicePkgs(normalized);
//         setCartPackage([]);
//       } catch (e) {
//         setSpError(e?.message || "โหลดแพ็คเกจไม่สำเร็จ");
//       } finally {
//         setSpLoading(false);
//       }
//     };
//     fetchPkgs();
//   }, [activeTab, orgId]);

//   const addPkgToCart = (pkg) => {
//     setCartPackage((prev) => {
//       const found = prev.find((it) => it.id === pkg.id);
//       if (found) {
//         return prev.map((it) =>
//           it.id === pkg.id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
//         );
//       }
//       return [
//         ...prev,
//         { id: pkg.id, name: pkg.name, price: pkg.price, qty: 1 },
//       ];
//     });
//   };

//   const fetchCustomerWithPackageByCode = async (cmCode) => {
//     const res = await api.post(API_GETCUSTOMERWITHPACKAGE, {
//       ORGID: orgId,
//       CMCODE: cmCode,
//     });
//     const row = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
//     if (!row) return null;
//     return {
//       id: row.cmCode || row.id,
//       code: row.cmCode || "",
//       name: row.cmName || "",
//       mobile: row.cmMobile || "",
//       phone: row.cmPhone || "",
//       subscriptions: row.subscriptions || [],
//       raw: row,
//     };
//   };

//   const handlePayPackages = async () => {
//     if (!orgId) return sa.error("ไม่พบ ORGID");
//     if (!selectedCustomerPackage?.code)
//       return sa.info("กรุณาเลือกลูกค้าในแท็บ 'ซื้อแพ็คเกจ' ก่อนทำรายการ");
//     if (cartPackage.length === 0) return sa.info("ยังไม่มีแพ็คเกจในตะกร้า");

//     // แปลง cart → ITEMS
//     const ITEMS = [];
//     cartPackage.forEach((p) => {
//       const n = Math.max(1, Number(p.qty || 0));
//       for (let i = 0; i < n; i += 1) ITEMS.push({ SVID: p.id });
//     });

//     const payload = {
//       ORGID: orgId,
//       ITEMS,
//       CMCODE: selectedCustomerPackage.code,
//     };

//     try {
//       setPaying(true);
//       setPayResult(null);

//       const res = await api.post(API_BUYSERVICEPACKAGE, payload);
//       const ok = res?.data?.statustext === "SUCCESS";
//       setPayResult(res?.data || null);

//       if (!ok) {
//         console.error("BuyServicePackage error:", res?.data);
//         return sa.error(res?.data?.message || "ทำรายการไม่สำเร็จ");
//       }

//       setCartPackage([]);

//       // รีเฟรชเครดิตลูกค้า แล้วอัปเดตทั้งสองฝั่ง
//       const refreshed = await fetchCustomerWithPackageByCode(
//         selectedCustomerPackage.code,
//       );
//       if (refreshed) {
//         setSelectedCustomerLaundry(refreshed);
//         setSelectedCustomerPackage(refreshed);
//       }

//       await sa.success(res?.data?.message || "ซื้อ Subscription สำเร็จ!");
//     } catch (e) {
//       console.error("BuyServicePackage exception:", e);
//       sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
//     } finally {
//       setPaying(false);
//     }
//   };

//   // ลบรายการในตะกร้าเปิดบิล
//   const removeLaundryItem = (item) => {
//     if (String(item.id).startsWith("custom-")) {
//       setCustomItems((prev) => prev.filter((x) => x.id !== item.id));
//       return;
//     }
//     const [svId, pdId] = String(item.id).split(":");
//     setLaundryServices((prev) =>
//       prev.map((svc) =>
//         String(svc.id) !== String(svId)
//           ? svc
//           : {
//               ...svc,
//               products: svc.products.map((p) =>
//                 String(p.id) === String(pdId) ? { ...p, qty: 0 } : p,
//               ),
//             },
//       ),
//     );
//   };

//   // ลบรายการในตะกร้าแพ็คเกจ
//   const removePackageItem = (id) => {
//     setCartPackage((prev) => prev.filter((x) => x.id !== id));
//     setServicePkgs((prev) =>
//       prev.map((it) => (it.id === id ? { ...it, qty: 0 } : it)),
//     );
//   };

//   // ช่วยตีความโหมดจาก type (จาก API)
//   const getModeFromType = (type) => {
//     const t = String(type || "").toLowerCase();
//     if (t.includes("กิโล") || t.includes("ชั่ง")) return "byWeight";
//     if (t.includes("แพ็คเกจ")) return "package";
//     return "perItem";
//   };

//   // หาโหมดที่ถูกต้องจาก svId ใน services เดิม
//   const resolveModeForService = (svId) => {
//     const svc = (originalServicesRef.current || []).find(
//       (s) => String(s.id) === String(svId),
//     );
//     return getModeFromType(svc?.type);
//   };

//   // ใช้สินค้าจาก "แพ็คเกจของลูกค้า" เท่านั้น และซ่อนแถบปุ่มบริการ
//   const applyCustomerPackageProducts = (svId) => {
//     const sub = (selectedCustomerLaundry?.subscriptions || []).find(
//       (s) => String(s.svId) === String(svId),
//     );
//     if (!sub) return;

//     const baseSvc = (originalServicesRef.current || []).find(
//       (s) => String(s.id) === String(svId),
//     );
//     if (!baseSvc) return;

//     const prods = (sub.products || []).map((p) => ({
//       id: p.pdId,
//       name: p.pdName,
//       price: Number(p.pdPrice ?? 0),
//       qty: 0,
//     }));

//     // ใช้ service ต้นฉบับ + ใส่สินค้าแพ็คเกจ
//     setLaundryServices([{ ...baseSvc, products: prods }]);
//     setSelectedServiceId(svId);
//     setLockServiceUI(true);
//   };

//   const restoreServiceProducts = () => {
//     const original = originalServicesRef.current || [];
//     setLaundryServices(
//       original.map((s) => ({
//         ...s,
//         products: (s.products || []).map((p) => ({ ...p, qty: 0 })),
//       })),
//     );
//     setLaundryMode("perItem");
//     setSelectedServiceId(original[0]?.id ?? null);
//     setSelectedCustomerPackageInfo(null);
//   };

//   // ===================================================================
//   // เปิดบิล
//   // ===================================================================
//   const [isBillModalOpen, setIsBillModalOpen] = useState(false);
//   const [receiveDate, setReceiveDate] = useState("");
//   const [dueDate, setDueDate] = useState("");
//   const [creatingBill, setCreatingBill] = useState(false);

//   const openBillModal = () => {
//     if (!selectedCustomerLaundry?.code) {
//       return sa.info("กรุณาเลือกลูกค้าในแท็บ 'เปิดบิล' ก่อนทำรายการ");
//     }
//     if (cartLaundry.length === 0) {
//       return sa.info("ยังไม่มีรายการในตะกร้า");
//     }

//     // ตั้งค่า default วันที่รับ/ส่ง
//     const toDateInput = (d) => d.toISOString().slice(0, 10);
//     const today = new Date();
//     const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

//     setReceiveDate(toDateInput(today));
//     setDueDate(toDateInput(tomorrow));
//     setIsBillModalOpen(true);
//   };

//   const handleSaveBill = async () => {
//     if (!orgId) return sa.error("ไม่พบ ORGID");
//     if (!receiveDate || !dueDate) {
//       return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");
//     }

//     // แปลง cartLaundry -> ITEMS (ข้าม custom item ไปก่อนเพราะไม่มี pdId)
//     const ITEMS = [];
//     cartLaundry.forEach((item) => {
//       if (String(item.id).startsWith("custom-")) return;

//       const [svIdStr, pdId] = String(item.id).split(":");
//       if (!pdId) return;

//       ITEMS.push({
//         pdId,
//         bdQty: Number(item.qty || 0),
//         pdPrice: Number(item.price || 0),
//       });
//     });

//     if (ITEMS.length === 0) {
//       return sa.info("ไม่พบรายการสินค้าที่สามารถเปิดบิลได้");
//     }

//     const payload = {
//       TNID: tnId,
//       ORGID: orgId,
//       BRID: brId,
//       CMCODE: selectedCustomerLaundry.code,
//       SVID: selectedServiceId,
//       BRECEIVE: receiveDate,
//       BDUEDATE: dueDate,
//       DISCOUNT: 0,
//       VAT: 0,
//       ITEMS,
//     };

//     try {
//       setCreatingBill(true);
//       const res = await api.post(API_CREATEBILL, payload);
//       const ok = res?.data?.statustext === "SUCCESS";

//       if (!ok) {
//         console.error("CreateBill error:", res?.data);
//         return sa.error(res?.data?.message || "เปิดบิลไม่สำเร็จ");
//       }

//       // เคลียร์ตะกร้า
//       setLaundryServices((prev) =>
//         prev.map((svc) => ({
//           ...svc,
//           products: svc.products.map((p) => ({ ...p, qty: 0 })),
//         })),
//       );
//       setCustomItems([]);

//       setIsBillModalOpen(false);
//       sa.success(res?.data?.message || "เปิดบิลสำเร็จ");
//     } catch (e) {
//       console.error("CreateBill exception:", e);
//       sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
//     } finally {
//       setCreatingBill(false);
//     }
//   };

//   const handleAddCustomerSubmit = async (e) => {
//     e.preventDefault();
//     if (submittingCustomer) return;

//     try {
//       if (!orgId || !tnId) {
//         return sa.error("ไม่พบข้อมูลองค์กรหรือเทนแนนต์ (ORGID/TNID)");
//       }

//       if (!customerForm.cmName.trim()) {
//         return sa.info("กรุณากรอกชื่อ/ชื่อลูกค้า");
//       }

//       if (!customerForm.cmMobile.trim()) {
//         return sa.info("กรุณากรอกเบอร์โทร");
//       }

//       setSubmittingCustomer(true);

//       const safeDigits = (v = "") => String(v).replace(/[^0-9]/g, "");
//       const fd = new FormData();

//       appendStr(fd, "TNID", tnId);
//       appendStr(fd, "ORGID", orgId);

//       const CMTYPE_LABEL =
//         customerType === "individual" ? "บุคคลธรรมดา" : "นิติบุคคล";
//       appendStr(fd, "CMTYPE", CMTYPE_LABEL);

//       // ฟอร์มแบบง่าย: เน้น CMNAME + CMMOBILE ส่วนอื่นๆ ว่างไว้
//       appendStr(fd, "CMNAME", customerForm.cmName.trim());
//       appendStr(fd, "CMMOBILE", safeDigits(customerForm.cmMobile));

//       appendStr(fd, "CMADDR", "");
//       appendStr(fd, "CMSUBDISTRICT", "");
//       appendStr(fd, "CMDISTRICT", "");
//       appendStr(fd, "CMPROVINCE", "");
//       appendStr(fd, "CMZIPCODE", "");

//       appendStr(fd, "CMBILLNAMETH", "");
//       appendStr(fd, "CMBILLNAMEEN", "");
//       appendStr(fd, "CBID", "");
//       appendStr(fd, "CMTAXID", "");
//       appendStr(fd, "CMEMAIL", "");
//       appendStr(fd, "CMADDR2", "");
//       appendStr(fd, "CMBILLADDR", "");
//       appendStr(fd, "CMBILLADDR2", "");
//       appendStr(fd, "CMBILLSUBDISTRICT", "");
//       appendStr(fd, "CMBILLDISTRICT", "");
//       appendStr(fd, "CMBILLPROVINCE", "");
//       appendStr(fd, "CMBILLZIPCODE", "");
//       appendStr(fd, "CMBILLMOBILE", "");
//       appendStr(fd, "CMBILLEMAIL", "");
//       appendStr(fd, "CMCONTACTNAME", "");
//       appendStr(fd, "CMCONTACTMOBILE", "");

//       const res = await api.post(API_ADDCUSTOMER, fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       // ถ้า backend ส่งข้อความมา
//       await sa.success(res?.data?.message || "เพิ่มลูกค้าสำเร็จ");

//       // เคลียร์ฟอร์ม + ปิด modal
//       setCustomerForm({ cmName: "", cmMobile: "" });
//       setIsAddModalOpen(false);
//     } catch (err) {
//       console.error("AddCustomer error:", err);
//       sa.error(
//         err?.response?.data?.message || err?.message || "เพิ่มลูกค้าไม่สำเร็จ",
//       );
//     } finally {
//       setSubmittingCustomer(false);
//     }
//   };

//   return (
//     <>
//       <style>{`
//   /* ===== MODE SWITCH ===== */
//   .mode-switch {
//     display: flex;
//     gap: 10px;
//     align-items: center;
//     margin-bottom: 10px;
//   }
//   .mode-pill, .svc-btn {
//     font-size: .75rem;
//     font-weight: 600;
//     height: 37px;
//     line-height: 1.1;
//   }
//   .mode-pill {
//     border-radius: 999px;
//     padding: 6px 14px;
//     border: 1px solid rgba(0,0,0,.06);
//     background: #fff;
//     color: #0f172a;
//     box-shadow: 0 3px 8px rgba(2,119,189,.08);
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
//   .mode-pill.active {
//     background: #1171ef;
//     color: #fff;
//     border-color: transparent;
//     box-shadow: 0 4px 12px rgba(17,113,239,.25);
//   }

//   /* ===== SERVICE GRID ===== */
// .svc-grid{
//   display: grid;
//   gap: 12px;
//   justify-content: start;   /* ✅ ชิดซ้าย ไม่กระจาย */
//   align-items: center;

//   /* ค่าเริ่มต้น (จอเล็ก) */
//   grid-template-columns: repeat(2, 180px);
// }

// .svc-btn{
//   width: 180px;            /* ✅ ไม่ยืด */
//   height: 37px;
//   border-radius: 9999px;
//   padding: 0 10px;

//   display:flex;
//   align-items:center;
//   justify-content:center;

//   font-size:.75rem;
//   font-weight:600;
//   line-height:1.1;

//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
// .svc-btn .sub{
//   font-size: 10px;
//   opacity: .85;
//   margin-left: 6px;
// }

//   /* ===== ITEM ROW ===== */
//   .item-row {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     padding: 10px 0;
//     border-bottom: 1px solid rgba(0,0,0,.06);
//     gap: 12px;
//   }
//   .qty {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//   }
//   .btn-qty {
//     width: 38px;
//     height: 38px;
//     border-radius: 10px;
//   }
//   .qty-input {
//     width: 80px;
//     text-align: center;
//   }
//   .unit {
//     margin-left: 6px;
//     color: #64748b;
//     white-space: nowrap;
//   }

//   /* ===== PAGING ===== */
//   .paging-wrap {
//     display: flex;
//     gap: 6px;
//     align-items: center;
//     justify-content: center;
//   }
//   .paging-btn {
//     min-width: 34px;
//     height: 34px;
//     padding: 0 10px;
//     border: 1px solid #e5e7eb;
//     border-radius: 8px;
//     background: #fff;
//   }
//   .paging-btn.active {
//     background: #1171ef;
//     color: #fff;
//     border-color: #1171ef;
//   }
//   .paging-btn.icon {
//     font-weight: 700;
//   }

//   /* ===== SUBSCRIPTION CARD GRID ===== */
//   .subs-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
//     gap: 10px;
//   }
//   .subs-card {
//     border-radius: 14px;
//     background: #f8fafc;
//     color: #0f172a;
//     border: 1px solid #e5e7eb;
//     padding: 12px 10px;
//   }

//   /* ===== Navbar / Dropdown ให้อยู่บนสุด ===== */
//   .navbar-top,
//   #navbar-main {
//     z-index: 2000 !important;
//   }

//   .navbar-top .dropdown-menu,
//   #navbar-main .dropdown-menu {
//     position: absolute !important;
//     z-index: 2100 !important;  /* สูงกว่าปุ่ม + ทั้งหมด */
//   }

//   /* ตะกร้าอย่าไปสร้าง z-index แข่งกับ navbar */
//   .cart-sticky {
//     z-index: auto !important;
//   }

//   /* แสดงพร้อมกันสูงสุด 5 แถว แล้วเลื่อนขึ้นลง */
// .product-scroll{
//   overflow-y: auto;
//   max-height: calc(5 * 62px); /* ปรับ 62px ให้พอดีกับความสูง 1 แถวของ item-row */
//   padding-right: 6px;
// }

// /* (optional) ทำ scrollbar ดูเนียนขึ้น */
// .product-scroll::-webkit-scrollbar{ width: 8px; }
// .product-scroll::-webkit-scrollbar-thumb{ background: rgba(148,163,184,.7); border-radius: 999px; }
// .product-scroll::-webkit-scrollbar-track{ background: rgba(226,232,240,.6); border-radius: 999px; }

// /* ===== SERVICE BUTTON : NOT ACTIVE ===== */
// .svc-btn.btn-outline-secondary{
//   border-width: 2px;                 /* ✅ หนาขึ้น */
//   border-color: #94a3b8;              /* slate-400 */
//   background-color: #fff;
//   color: #334155;                     /* slate-700 */
// }

// /* hover ของปุ่มไม่ active */
// .svc-btn.btn-outline-secondary:hover{
//   border-color: #64748b;              /* slate-500 */
//   background-color: #f8fafc;
//   color: #1e293b;
// }

// /* ===== SERVICE BUTTON : ACTIVE ===== */
// .svc-btn.btn-primary{
//   border-width: 0;                    /* active ไม่มีเส้น */
// }

// /* ===== SERVICE GRID (LOCK 5 COL / 2 COL) ===== */
// .svc-grid{
//   display: grid;
//   gap: 12px;
//   justify-content: start;     /* ชิดซ้าย */
//   width: fit-content;         /* ✅ ทำให้ grid หดตามความกว้างจริง ไม่เกิดช่องว่าง */
//   max-width: 100%;
// }

// /* จอเล็ก: 2 ปุ่ม */
// @media (max-width: 767.98px){
//   .svc-grid{
//     grid-template-columns: repeat(2, 140px);
//   }
// }

// /* จอกลาง+ใหญ่: 4 ปุ่ม */
// @media (min-width: 768px){
//   .svc-grid{
//     grid-template-columns: repeat(5, 180px);
//   }
// }

// /* ปุ่ม */
// .svc-btn{
//   width: 180px;
//   height: 37px;
//   border-radius: 9999px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// `}</style>

//       <div className="order-page">
//         <Header />
//         <Container className="mt--7" fluid>
//           <Card>
//             <CardHeader
//               className="bg-white border-0"
//               style={{ padding: "1.25rem 1.5rem" }}
//             >
//               <Row className="align-items-center">
//                 <Col xs="12" lg="6">
//                   <h6 className="mb-0">เปิดบิล</h6>
//                 </Col>
//                 <Col xs="12" lg="6" className="mt-3 mt-lg-0">
//                   <div className="d-flex justify-content-lg-end">
//                     <div className="w-100 w-lg-2/3">
//                       <label
//                         htmlFor="customer-search"
//                         className="form-label mb-1"
//                         style={{ fontWeight: 600, color: "#334155" }}
//                       >
//                         ค้นหาลูกค้า
//                       </label>
//                       {activeTab === "laundry" ? (
//                         <SearchBoxLaundry inputId="customer-search-laundry" />
//                       ) : (
//                         <SearchBoxPackage inputId="customer-search-package" />
//                       )}
//                     </div>
//                   </div>
//                 </Col>
//               </Row>
//             </CardHeader>

//             <Nav tabs className="mt-3">
//               <NavItem>
//                 <NavLink
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setActiveTab("laundry");
//                   }}
//                   className={activeTab === "laundry" ? "active" : ""}
//                 >
//                   เปิดบิล
//                 </NavLink>
//               </NavItem>
//               <NavItem>
//                 <NavLink
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setActiveTab("package");
//                   }}
//                   className={activeTab === "package" ? "active" : ""}
//                 >
//                   ซื้อแพ็คเกจ
//                 </NavLink>
//               </NavItem>
//             </Nav>

//             <CardBody
//               className="border-0 p-2 p-lg-4"
//               style={{ backgroundColor: "#f7f9fb" }}
//             >
//               <Row className="g-0 g-lg-4 px-0 px-lg-3">
//                 {/* Middle */}
//                 <Col xs="12" md="12" lg={8} className="mb-3 px-0 px-lg-2">
//                   <Card className="shadow-sm h-100">
//                     <CardBody style={{ padding: "1rem" }}>
//                       {/* ===== โหมดย่อย + ปุ่มบริการ (ซ่อนถ้า lockServiceUI=true) ===== */}
//                       {activeTab === "laundry" && !lockServiceUI && (
//                         <>
//                           <Nav tabs className="mb-3">
//                             <NavItem>
//                               <NavLink
//                                 href="#"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   setLaundryMode("perItem");
//                                   setSelectedServiceId(null);
//                                 }}
//                                 className={
//                                   laundryMode === "perItem" ? "active" : ""
//                                 }
//                               >
//                                 รายชิ้น
//                               </NavLink>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink
//                                 href="#"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   setLaundryMode("package");
//                                   setSelectedServiceId(null);
//                                 }}
//                                 className={
//                                   laundryMode === "package" ? "active" : ""
//                                 }
//                               >
//                                 แพ็คเกจ
//                               </NavLink>
//                             </NavItem>
//                             <NavItem>
//                               <NavLink
//                                 href="#"
//                                 onClick={(e) => {
//                                   e.preventDefault();
//                                   setLaundryMode("byWeight");
//                                   setSelectedServiceId(null);
//                                 }}
//                                 className={
//                                   laundryMode === "byWeight" ? "active" : ""
//                                 }
//                               >
//                                 ชั่งกิโล
//                               </NavLink>
//                             </NavItem>
//                           </Nav>

//                           <div className="mb-4">
//                             <div className="svc-grid">
//                               {laundryLoading && (
//                                 <span className="text-muted">
//                                   กำลังโหลดบริการ...
//                                 </span>
//                               )}
//                               {!laundryLoading && laundryError && (
//                                 <span className="text-danger">
//                                   {laundryError}
//                                 </span>
//                               )}
//                               {!laundryLoading &&
//                                 !laundryError &&
//                                 displayLaundryServices.map((svc) => {
//                                   const active = selectedServiceId === svc.id;
//                                   return (
//                                     <Button
//                                       key={svc.id}
//                                       size="sm"
//                                       outline={!active}
//                                       color={active ? "primary" : "secondary"}
//                                       className="svc-btn"
//                                       onClick={() =>
//                                         handleSelectService(svc.id)
//                                       }
//                                       aria-pressed={active}
//                                     >
//                                       <span className="main">{svc.name}</span>
//                                       <span className="sub">
//                                         ({svc.type || "รายชิ้น"})
//                                       </span>
//                                     </Button>
//                                   );
//                                 })}
//                             </div>
//                           </div>
//                         </>
//                       )}

//                       {/* แถบสำหรับปลดล็อกกลับไปเลือกบริการ/แพ็คเกจเดิม */}
//                       {activeTab === "laundry" &&
//                         selectedService &&
//                         lockServiceUI && (
//                           <div className="d-flex justify-content-between align-items-center mb-2">
//                             <div style={{ fontSize: 14, color: "#0f172a" }}>
//                               {currentPackageName ? (
//                                 <>
//                                   แพ็คเกจที่เลือก:{" "}
//                                   <strong>{currentPackageName}</strong>
//                                 </>
//                               ) : (
//                                 <span>ใช้แพ็คเกจลูกค้า</span>
//                               )}
//                             </div>

//                             <Button
//                               size="sm"
//                               color="danger"
//                               outline
//                               className="rounded-pill"
//                               onClick={() => {
//                                 setLockServiceUI(false);
//                                 restoreServiceProducts();
//                               }}
//                             >
//                               เปลี่ยนบริการ/แพ็คเกจ
//                             </Button>
//                           </div>
//                         )}

//                       {/* ================= Laundry: รายสินค้า ================= */}
//                       {activeTab === "laundry" && selectedService && (
//                         <>
//                           <div ref={listRef} className="product-scroll">
//                             {productsAll.map((p) => (
//                               <div key={p.id} className="item-row">
//                                 <div style={{ fontWeight: 500 }}>{p.name}</div>
//                                 <div className="qty">
//                                   <Button
//                                     color="light"
//                                     onClick={() => decQtyLaundry(p.id)}
//                                     className="btn-qty"
//                                   >
//                                     –
//                                   </Button>

//                                   <Input
//                                     type="number"
//                                     min="0"
//                                     value={p.qty === "" ? "" : Number(p.qty)}
//                                     onChange={(e) =>
//                                       updateQtyLaundry(p.id, e.target.value)
//                                     }
//                                     className="qty-input"
//                                   />

//                                   <Button
//                                     onClick={() => incQtyLaundry(p.id)}
//                                     className="btn-qty"
//                                     style={{
//                                       backgroundColor: "#1171ef",
//                                       color: "#fff",
//                                       border: "none",
//                                     }}
//                                   >
//                                     +
//                                   </Button>

//                                   <span className="unit">
//                                     {selectedService.unit || "ตัว/ชิ้น"}
//                                   </span>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>

//                           {/* กรอกสินค้าเอง */}
//                           {/* <div className="mt-3 mb-2 d-flex justify-content-end">
//                             <Button
//                               color="primary"
//                               outline
//                               size="sm"
//                               className="rounded-pill"
//                               onClick={addCustomItem}
//                             >
//                               กรอกสินค้าเอง
//                             </Button>
//                           </div> */}

//                           {customItems.map((it) => (
//                             <div key={it.id} className="item-row custom-item">
//                               <div className="custom-name">
//                                 <Input
//                                   type="text"
//                                   placeholder="พิมพ์ชื่อสินค้า"
//                                   value={it.name}
//                                   onChange={(e) =>
//                                     updateCustomName(it.id, e.target.value)
//                                   }
//                                   bsSize="sm"
//                                 />
//                               </div>
//                               <div
//                                 className="price"
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 6,
//                                 }}
//                               >
//                                 <span className="price-label">ราคา</span>
//                                 <Input
//                                   type="number"
//                                   min="0"
//                                   value={
//                                     it.price === "" ? "" : Number(it.price)
//                                   }
//                                   onChange={(e) =>
//                                     updateCustomPrice(it.id, e.target.value)
//                                   }
//                                   bsSize="sm"
//                                   className="price-input"
//                                   style={{ width: 100 }}
//                                 />
//                                 <span className="currency">฿</span>
//                               </div>
//                               <div className="qty">
//                                 <Button
//                                   color="light"
//                                   onClick={() => decCustomQty(it.id)}
//                                   className="btn-qty"
//                                 >
//                                   –
//                                 </Button>
//                                 <Input
//                                   type="number"
//                                   min="0"
//                                   value={it.qty === "" ? "" : Number(it.qty)}
//                                   onChange={(e) =>
//                                     updateCustomQty(it.id, e.target.value)
//                                   }
//                                   className="qty-input"
//                                 />
//                                 <Button
//                                   onClick={() => incCustomQty(it.id)}
//                                   className="btn-qty"
//                                   style={{
//                                     backgroundColor: "#1171ef",
//                                     color: "#fff",
//                                     border: "none",
//                                   }}
//                                 >
//                                   +
//                                 </Button>
//                                 <span className="unit">
//                                   {selectedService?.unit || "ตัว/ชิ้น"}
//                                 </span>
//                               </div>
//                             </div>
//                           ))}
//                         </>
//                       )}

//                       {/* ================= Package list (แท็บซื้อแพ็คเกจ) ================= */}
//                       {activeTab === "package" && (
//                         <>
//                           {!spLoading && spError && (
//                             <div className="text-center text-danger py-3">
//                               {spError}
//                             </div>
//                           )}
//                           {!spLoading &&
//                             !spError &&
//                             servicePkgs.length === 0 && (
//                               <div className="text-center text-muted py-3">
//                                 ยังไม่มีแพ็คเกจ
//                               </div>
//                             )}

//                           <div
//                             style={{
//                               display: "grid",
//                               gridTemplateColumns:
//                                 "repeat(auto-fit, minmax(260px, 1fr))",
//                               gap: 16,
//                             }}
//                             className="package-grid"
//                           >
//                             {servicePkgs.map((p) => (
//                               <Card
//                                 key={p.id}
//                                 onClick={() => addPkgToCart(p)}
//                                 role="button"
//                                 tabIndex={0}
//                                 style={{
//                                   borderRadius: 14,
//                                   backgroundColor: "#0ea5e9",
//                                   color: "#fff",
//                                   cursor: "pointer",
//                                   transition:
//                                     "transform .08s ease, box-shadow .2s ease, background-color .2s ease",
//                                   boxShadow:
//                                     "0 4px 10px rgba(17, 113, 239, 0.3)",
//                                 }}
//                                 onMouseDown={(e) => {
//                                   e.currentTarget.style.transform =
//                                     "scale(0.98)";
//                                 }}
//                                 onMouseUp={(e) => {
//                                   e.currentTarget.style.transform = "scale(1)";
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   e.currentTarget.style.transform = "scale(1)";
//                                 }}
//                               >
//                                 <CardBody style={{ padding: "16px 18px" }}>
//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <div>
//                                       <div
//                                         style={{
//                                           fontWeight: 700,
//                                           fontSize: 16,
//                                         }}
//                                       >
//                                         {p.name}
//                                       </div>
//                                       <div
//                                         style={{
//                                           fontSize: 12,
//                                           opacity: 0.9,
//                                           marginTop: 4,
//                                         }}
//                                       >
//                                         {p.unit ? `(${p.qty} ${p.unit})` : ""} •{" "}
//                                         {p.type}
//                                       </div>
//                                     </div>
//                                     <div style={{ textAlign: "right" }}>
//                                       <div style={{ fontWeight: 700 }}>
//                                         {p.price.toLocaleString()} ฿
//                                       </div>
//                                       {p.leadtime ? (
//                                         <div
//                                           style={{ fontSize: 12, opacity: 0.9 }}
//                                         >
//                                           {p.leadtime} วัน
//                                         </div>
//                                       ) : null}
//                                     </div>
//                                   </div>
//                                 </CardBody>
//                               </Card>
//                             ))}
//                           </div>
//                         </>
//                       )}
//                     </CardBody>
//                   </Card>
//                 </Col>

//                 {/* Right: Cart */}
//                 <Col xs="12" md="12" lg={4} className="px-0 px-lg-2">
//                   {activeTab === "laundry" ? (
//                     <Card className="shadow-sm">
//                       <div
//                         className="position-sticky cart-sticky"
//                         style={{ top: 72, width: "100%" }}
//                       >
//                         <CardBody>
//                           <h5 className="mb-3">ตะกร้า (เปิดบิล)</h5>
//                           {activeTab === "laundry" &&
//                             selectedCustomerLaundry && (
//                               <>
//                                 <div
//                                   className="mb-2"
//                                   style={{ fontSize: 12, color: "#475569" }}
//                                 >
//                                   ลูกค้าที่เลือก:{" "}
//                                   <strong>
//                                     {selectedCustomerLaundry.code} -{" "}
//                                     {selectedCustomerLaundry.name}
//                                   </strong>
//                                 </div>

//                                 {currentPackageName && (
//                                   <div
//                                     className="mb-2"
//                                     style={{ fontSize: 12, color: "#475569" }}
//                                   >
//                                     แพ็คเกจที่เลือก:{" "}
//                                     <strong>{currentPackageName}</strong>
//                                   </div>
//                                 )}
//                               </>
//                             )}
//                           <ListGroup className="mb-3">
//                             {cartLaundry.length === 0 && (
//                               <ListGroupItem className="text-center text-muted">
//                                 ยังไม่มีรายการ
//                               </ListGroupItem>
//                             )}
//                             {cartLaundry.map((p) => (
//                               <ListGroupItem
//                                 key={p.id}
//                                 className="d-flex align-items-center justify-content-between mb-2"
//                                 style={{
//                                   borderRadius: 12,
//                                   border: "1px solid #f1f1f1",
//                                 }}
//                               >
//                                 <div style={{ fontWeight: 700 }}>{p.name}</div>

//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{ gap: 10 }}
//                                 >
//                                   <div
//                                     style={{
//                                       whiteSpace: "nowrap",
//                                       color: "#64748b",
//                                     }}
//                                   >
//                                     {p.qty} × {p.price.toLocaleString()} ฿
//                                   </div>
//                                   <Button
//                                     color="link"
//                                     onClick={() => removeLaundryItem(p)}
//                                     title="ลบรายการ"
//                                     style={{ padding: 0, lineHeight: 0 }}
//                                     aria-label="ลบรายการ"
//                                   >
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       width="18"
//                                       height="18"
//                                       viewBox="0 0 24 24"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       strokeWidth="2"
//                                       strokeLinecap="round"
//                                       strokeLinejoin="round"
//                                       style={{ color: "#e11d48" }}
//                                     >
//                                       <polyline points="3 6 5 6 21 6"></polyline>
//                                       <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
//                                       <path d="M10 11v6"></path>
//                                       <path d="M14 11v6"></path>
//                                       <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
//                                     </svg>
//                                   </Button>
//                                 </div>
//                               </ListGroupItem>
//                             ))}
//                           </ListGroup>

//                           <div
//                             className="p-2 rounded mb-3"
//                             style={{
//                               background: "#f1f5ff",
//                               border: "1px dashed #bcd1ff",
//                             }}
//                           >
//                             <div className="d-flex justify-content-between">
//                               <span>ยอดรวม</span>
//                               <strong>{totalLaundry.toLocaleString()} ฿</strong>
//                             </div>
//                           </div>

//                           <Button
//                             block
//                             style={{
//                               height: 48,
//                               fontWeight: 700,
//                               backgroundColor: "#1171ef",
//                               color: "#fff",
//                               border: "none",
//                             }}
//                             onClick={openBillModal}
//                           >
//                             เปิดบิล
//                           </Button>
//                         </CardBody>
//                       </div>
//                     </Card>
//                   ) : (
//                     <Card className="shadow-sm">
//                       <div
//                         className="position-sticky cart-sticky"
//                         style={{ top: 72, width: "100%" }}
//                       >
//                         <CardBody>
//                           <h5 className="mb-3">ตะกร้าแพ็คเกจ</h5>
//                           {activeTab === "package" &&
//                             selectedCustomerPackage && (
//                               <div
//                                 className="mb-2"
//                                 style={{ fontSize: 12, color: "#475569" }}
//                               >
//                                 ลูกค้าที่เลือก:{" "}
//                                 <strong>
//                                   {selectedCustomerPackage.code} -{" "}
//                                   {selectedCustomerPackage.name}
//                                 </strong>
//                               </div>
//                             )}
//                           <ListGroup className="mb-3">
//                             {cartPackage.length === 0 && (
//                               <ListGroupItem className="text-center text-muted">
//                                 ยังไม่มีแพ็คเกจ
//                               </ListGroupItem>
//                             )}
//                             {cartPackage.map((p) => (
//                               <ListGroupItem
//                                 key={p.id}
//                                 className="mb-2"
//                                 style={{
//                                   borderRadius: 12,
//                                   border: "1px solid #f1f1f1",
//                                   padding: "0.9rem 1rem",
//                                 }}
//                               >
//                                 <div className="d-flex justify-content-between align-items-center">
//                                   <div>
//                                     <div style={{ fontWeight: 700 }}>
//                                       {p.name}
//                                     </div>
//                                     <div
//                                       style={{ fontSize: 12, color: "#6b7280" }}
//                                     >
//                                       จำนวนซื้อ {p.qty} ชุด
//                                     </div>
//                                   </div>

//                                   <div
//                                     className="d-flex align-items-center"
//                                     style={{ gap: 10 }}
//                                   >
//                                     <div
//                                       style={{
//                                         textAlign: "right",
//                                         whiteSpace: "nowrap",
//                                       }}
//                                     >
//                                       {p.price.toLocaleString()} ฿ / ชุด
//                                     </div>
//                                     <Button
//                                       color="link"
//                                       onClick={() => removePackageItem(p.id)}
//                                       title="ลบแพ็คเกจนี้"
//                                       style={{ padding: 0, lineHeight: 0 }}
//                                       aria-label="ลบแพ็คเกจนี้"
//                                     >
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="18"
//                                         height="18"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         style={{ color: "#e11d48" }}
//                                       >
//                                         <polyline points="3 6 5 6 21 6"></polyline>
//                                         <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
//                                         <path d="M10 11v6"></path>
//                                         <path d="M14 11v6"></path>
//                                         <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
//                                       </svg>
//                                     </Button>
//                                   </div>
//                                 </div>
//                               </ListGroupItem>
//                             ))}
//                           </ListGroup>

//                           <div
//                             className="p-2 rounded mb-3"
//                             style={{
//                               background: "#f1f5ff",
//                               border: "1px dashed #bcd1ff",
//                             }}
//                           >
//                             <div className="d-flex justify-content-between">
//                               <span>ยอดรวม</span>
//                               <strong>{totalPackage.toLocaleString()} ฿</strong>
//                             </div>
//                           </div>

//                           <Button
//                             block
//                             onClick={handlePayPackages}
//                             disabled={paying || cartPackage.length === 0}
//                             style={{
//                               height: 48,
//                               fontWeight: 700,
//                               backgroundColor: "#1171ef",
//                               color: "#fff",
//                               border: "none",
//                             }}
//                           >
//                             {paying ? (
//                               <span className="spinner-border spinner-border-sm" />
//                             ) : (
//                               "ชำระเงิน"
//                             )}
//                           </Button>
//                         </CardBody>
//                       </div>
//                     </Card>
//                   )}
//                 </Col>
//               </Row>
//             </CardBody>
//           </Card>
//         </Container>

//         {/* Modal: แพ็คเกจของลูกค้า */}
//         <Modal
//           isOpen={isPkgModalOpen}
//           toggle={togglePkgModal}
//           size="lg"
//           centered
//           backdrop="static"
//           keyboard={false}
//         >
//           <ModalHeader toggle={togglePkgModal}>
//             แพ็คเกจลูกค้า
//             {selectedCustomerLaundry ? `: ${selectedCustomerLaundry.name}` : ""}
//           </ModalHeader>

//           <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
//             {(() => {
//               const subs = (selectedCustomerLaundry?.subscriptions || [])
//                 .map((s) => ({
//                   stId: s.stId,
//                   svId: s.svId,
//                   name: s.svName || "-",
//                   amount: Number(s.amount || 0),
//                   used: Number(s.used || 0),
//                   remaining: Number(s.remaining || 0),
//                   startDate: s.startDate,
//                   endDate: s.endDate,
//                   status: s.status, // 'Y' = ใช้งานได้
//                   products: s.products || [],
//                 }))
//                 .sort((a, b) => b.remaining - a.remaining);

//               if (subs.length === 0) {
//                 return (
//                   <div className="text-center text-muted py-3">
//                     ลูกค้ายังไม่มีแพ็คเกจ
//                   </div>
//                 );
//               }

//               return (
//                 <Row>
//                   <Col xs="12">
//                     <div className="subs-grid">
//                       {subs.map((pkg) => {
//                         const isActive = pkg.status === "Y";
//                         const isOut = pkg.remaining <= 0;
//                         const isClickable = isActive && !isOut; // ใช้งานได้?
//                         return (
//                           <Button
//                             key={`${pkg.stId}-${pkg.svId}`}
//                             disabled={!isClickable}
//                             onClick={() => {
//                               // เก็บข้อมูลแพ็กเกจที่เลือกไว้แสดงบนหน้าจอ
//                               setSelectedCustomerPackageInfo(pkg);

//                               const nextMode =
//                                 resolveModeForService(pkg.svId) || "perItem";
//                               setLaundryMode(nextMode);
//                               setSelectedServiceId(pkg.svId);
//                               setLockServiceUI(true);
//                               setIsPkgModalOpen(false);
//                               applyCustomerPackageProducts(pkg.svId);
//                             }}
//                             className={`w-100 subs-card ${
//                               isClickable ? "subs-active" : "subs-disabled"
//                             }`}
//                           >
//                             <span style={{ fontSize: 15, marginBottom: 4 }}>
//                               {pkg.name}
//                             </span>
//                             <span style={{ fontSize: 12 }}>
//                               คงเหลือ {pkg.remaining} / {pkg.amount} ครั้ง
//                             </span>
//                             {pkg.endDate && (
//                               <span style={{ fontSize: 11 }}>
//                                 หมดอายุ:{" "}
//                                 {new Date(pkg.endDate).toLocaleDateString()}
//                               </span>
//                             )}
//                           </Button>
//                         );
//                       })}
//                     </div>
//                   </Col>
//                 </Row>
//               );
//             })()}
//           </ModalBody>
//         </Modal>

//         {/* Modal: เพิ่มลูกค้า */}
//         <Modal
//           isOpen={isAddModalOpen}
//           toggle={toggleAddModal}
//           size="lg"
//           centered
//           backdrop="static"
//           keyboard={false}
//         >
//           <ModalHeader toggle={toggleAddModal}>เพิ่มลูกค้า</ModalHeader>
//           <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
//             <Form onSubmit={handleAddCustomerSubmit}>
//               <div className="pl-lg-4">
//                 <Row className="mb-3">
//                   <Col lg="12">
//                     <div style={{ display: "flex", gap: 8 }}>
//                       <Button
//                         size="sm"
//                         color={
//                           customerType === "individual"
//                             ? "primary"
//                             : "secondary"
//                         }
//                         outline={customerType !== "individual"}
//                         className="rounded-pill"
//                         type="button"
//                         onClick={() => setCustomerType("individual")}
//                       >
//                         บุคคลธรรมดา
//                       </Button>
//                       <Button
//                         size="sm"
//                         color={
//                           customerType === "juristic" ? "primary" : "secondary"
//                         }
//                         outline={customerType !== "juristic"}
//                         className="rounded-pill"
//                         type="button"
//                         onClick={() => setCustomerType("juristic")}
//                       >
//                         นิติบุคคล
//                       </Button>
//                     </div>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col lg="6">
//                     <FormGroup>
//                       <label className="form-control-label required">
//                         {isCompany ? "ชื่อบริษัท / นิติบุคคล" : "ชื่อลูกค้า"}
//                       </label>
//                       <Input
//                         className="form-control-alternative"
//                         type="text"
//                         name="cmName"
//                         value={customerForm.cmName}
//                         onChange={handleChangeCustomerForm}
//                         required
//                       />
//                     </FormGroup>
//                   </Col>
//                   <Col lg="6">
//                     <FormGroup>
//                       <label className="form-control-label required">
//                         เบอร์โทร
//                       </label>
//                       <Input
//                         className="form-control-alternative"
//                         type="text"
//                         name="cmMobile"
//                         value={customerForm.cmMobile}
//                         onChange={handleChangeCustomerForm}
//                         required
//                       />
//                     </FormGroup>
//                   </Col>
//                 </Row>
//               </div>

//               <div className="text-right mt-4">
//                 <Button
//                   color="primary"
//                   type="submit"
//                   style={{ minWidth: 120 }}
//                   disabled={submittingCustomer}
//                 >
//                   {submittingCustomer ? (
//                     <span className="spinner-border spinner-border-sm" />
//                   ) : (
//                     "บันทึก"
//                   )}
//                 </Button>
//               </div>
//             </Form>
//           </ModalBody>
//         </Modal>

//         {/* Modal: เปิดบิล - เลือกวันที่รับ/ส่งผ้า */}
//         <Modal
//           isOpen={isBillModalOpen}
//           toggle={() => {
//             if (!creatingBill) setIsBillModalOpen(false);
//           }}
//           centered
//           backdrop="static"
//           keyboard={false}
//         >
//           <ModalHeader
//             toggle={creatingBill ? undefined : () => setIsBillModalOpen(false)}
//           >
//             กำหนดวันที่รับผ้า / วันที่ส่งผ้า
//           </ModalHeader>
//           <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
//             <Form>
//               <FormGroup>
//                 <label className="form-control-label">วันที่รับผ้า</label>
//                 <Input
//                   type="date"
//                   value={receiveDate}
//                   onChange={(e) => setReceiveDate(e.target.value)}
//                 />
//               </FormGroup>
//               <FormGroup>
//                 <label className="form-control-label">วันที่ส่งผ้า</label>
//                 <Input
//                   type="date"
//                   value={dueDate}
//                   onChange={(e) => setDueDate(e.target.value)}
//                 />
//               </FormGroup>

//               <div className="text-right mt-4">
//                 <Button
//                   color="secondary"
//                   className="mr-2"
//                   onClick={() => setIsBillModalOpen(false)}
//                   disabled={creatingBill}
//                 >
//                   ยกเลิก
//                 </Button>
//                 <Button
//                   color="primary"
//                   onClick={handleSaveBill}
//                   disabled={creatingBill}
//                   style={{ minWidth: 120 }}
//                 >
//                   {creatingBill ? (
//                     <span className="spinner-border spinner-border-sm" />
//                   ) : (
//                     "บันทึก"
//                   )}
//                 </Button>
//               </div>
//             </Form>
//           </ModalBody>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default Order;

import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  ListGroup,
  ListGroupItem,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";
import { useSessionStore } from "../../stores/sessionStore";
import { useSettingStore } from "../../stores/settingStore";
import { api } from "../../config/middleware";
import {
  API_GETSERVICEWITHPRODUCTS,
  API_GETSERVICEPACKAGES,
  API_BUYSERVICEPACKAGE,
  API_GETCUSTOMERWITHPACKAGE,
  API_CREATEBILL,
  API_ADDCUSTOMER,
  API_GETSETTING,
  API_GETPRODUCTS,
  API_ADDPRODUCT,
} from "../../config/api";

const AddDetailFab = ({ onClick }) => {
  return (
    <button
      type="button"
      className="add-detail-fab"
      onClick={onClick}
      title="เพิ่มรายการ"
    >
      <i className="ni ni-fat-add" />
    </button>
  );
};

const Order = () => {
  const sa = {
    info: (text, title = "แจ้งเตือน") =>
      Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
    success: (text, title = "สำเร็จ") =>
      Swal.fire({
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 2000,
      }),
    error: (text, title = "เกิดข้อผิดพลาด") =>
      Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
  };

  const orgId = useSessionStore((s) => s.profile?.orgId);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const brId = useSessionStore((s) => s.profile?.brId);

  const setBillMode = useSettingStore((s) => s.setBillMode);

  useEffect(() => {
    const fetchSetting = async () => {
      const res = await api.get(API_GETSETTING, {
        params: { TNID: tnId, ORGID: orgId, BRID: brId },
      });

      if (res.data?.statustext === "SUCCESS") {
        setBillMode(res.data.data.billMode);
      }
    };

    if (tnId != null && orgId != null && brId != null) {
      fetchSetting();
    }
  }, [tnId, orgId, brId]);

  // ---------- Tabs ----------
  const [activeTab, setActiveTab] = useState("laundry"); // "laundry" | "package"

  // ---------- Sub-mode (เฉพาะแท็บเปิดบิล) ----------
  const [laundryMode, setLaundryMode] = useState("perItem"); // 'perItem' | 'package' | 'byWeight'

  // ---------- Search / Customer ----------
  const buildCustomerQuery = (term) => {
    const t = String(term || "").trim();
    if (!t) return null;

    // รหัสลูกค้า: CUS..., CM..., หรือรูปแบบตัวอักษร+ตัวเลข เช่น AB123
    if (/^(CUS|CM)/i.test(t) || /^[A-Za-z]{1,5}\d{1,}$/i.test(t)) {
      return { CMCODE: t };
    }

    // เบอร์โทร (ตัวเลขล้วน)
    if (/^\d+$/.test(t)) return { CMMOBILE: t };

    // ชื่อ
    return { CMNAME: t };
  };

  const [selectedCustomerLaundry, setSelectedCustomerLaundry] = useState(null); // ใช้กับแท็บ "เปิดบิล"
  const [selectedCustomerPackage, setSelectedCustomerPackage] = useState(null); // ใช้กับแท็บ "ซื้อแพ็คเกจ"
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isPkgModalOpen, setIsPkgModalOpen] = useState(false);

  const [customerType, setCustomerType] = useState("individual"); // "individual" | "juristic"

  const [submittingCustomer, setSubmittingCustomer] = useState(false);

  const [customerForm, setCustomerForm] = useState({
    cmName: "",
    cmMobile: "",
  });

  const handleChangeCustomerForm = (e) => {
    const { name, value } = e.target;
    setCustomerForm((prev) => ({ ...prev, [name]: value }));
  };

  const appendStr = (fd, key, val) => {
    if (val === undefined || val === null) return;
    fd.append(key, String(val));
  };

  const isCompany = customerType === "juristic";

  const handleAddCustomer = () => setIsAddModalOpen(true);
  const toggleAddModal = () => setIsAddModalOpen((v) => !v);
  const togglePkgModal = () => setIsPkgModalOpen((v) => !v);

  // ===================================================================
  // ✅ CUSTOMER PRODUCTS (ถ้าลูกค้ามีสินค้า ให้โชว์สินค้าลูกค้า)
  // ===================================================================
  const [customerProducts, setCustomerProducts] = useState([]); // {id,name,price,qty}
  const [allowCustomerProducts, setAllowCustomerProducts] = useState(true);

  const setCustomerProductsFromCus = (cus) => {
    const arr = Array.isArray(cus?.products) ? cus.products : [];
    if (arr.length === 0) {
      setCustomerProducts([]);
      return;
    }
    const normalized = arr.map((p) => ({
      id: p.pdId,
      name: p.pdName,
      price: Number(p.pdPrice ?? 0),
      pdWeight: Number(p.pdWeight ?? 0),
      qty: 0,
    }));
    setCustomerProducts(normalized);
  };

  const clearCustomerProducts = () => setCustomerProducts([]);

  const fetchProductsByCustomer = async (orgId, cmCode) => {
    const res = await api.get(API_GETPRODUCTS, {
      params: { ORGID: orgId, CMCODE: "ORG" },
    });

    const rows = Array.isArray(res?.data?.data) ? res.data.data : [];

    // res ตามรูป: { pdId, pdCode, pdName, pdPrice, ... }
    return rows.map((p) => ({
      id: p.pdId,
      name: p.pdName,
      price: Number(p.pdPrice ?? 0),
      pdWeight: Number(p.pdWeight ?? 0),
      qty: 0,
    }));
  };

  const pickCustomerLaundry = async (cus) => {
    setSelectedCustomerLaundry(cus);
    setSelectedCustomerPackageInfo(null);

    setLockServiceUI(false);
    setAllowCustomerProducts(true);

    try {
      // ✅ ถ้าลูกค้ามีสินค้าใน object (จาก API_GETCUSTOMERWITHPACKAGE) ใช้เลย
      if (Array.isArray(cus?.products) && cus.products.length > 0) {
        setCustomerProductsFromCus(cus);

        setLaundryServices((prev) =>
          prev.map((svc) => ({
            ...svc,
            products: (svc.products || []).map((p) => ({ ...p, qty: 0 })),
          })),
        );
      } else {
        // ✅ ถ้าไม่มีสินค้า -> ไปดึงจาก API_GETPRODUCTS (ORGID + CMCODE)
        clearCustomerProducts();

        if (!orgId || !cus?.code) {
          // กันกรณีไม่มี orgId/cmcode
          restoreServiceProducts();
        } else {
          const products = await fetchProductsByCustomer(orgId, cus.code);
          setCustomerProducts(products);

          // เคลียร์ qty ของ service products กันปน
          setLaundryServices((prev) =>
            prev.map((svc) => ({
              ...svc,
              products: (svc.products || []).map((p) => ({ ...p, qty: 0 })),
            })),
          );
        }
      }

      // เปิด modal เลือกแพ็คเกจ ถ้ามี
      const subs = Array.isArray(cus.subscriptions) ? cus.subscriptions : [];
      if (subs.length > 0) setIsPkgModalOpen(true);
      else setIsPkgModalOpen(false);
    } catch (e) {
      console.error("fetchProductsByCustomer error:", e);
      // fallback เป็นของเดิม
      restoreServiceProducts();
    }
  };

  const pickCustomerPackage = (cus) => {
    setSelectedCustomerPackage(cus);
  };

  const SearchBoxBase = ({ className, inputId, onPick }) => {
    const inputRef = useRef(null);
    const composingRef = useRef(false);
    const debounceRef = useRef(null);
    const reqCounter = useRef(0);

    const [isSearching, setIsSearching] = useState(false);
    const [cusErr, setCusErr] = useState("");
    const [searchResults, setSearchResults] = useState([]);

    const fireSearch = async (raw) => {
      const term = String(raw || "").trim();
      setCusErr("");
      if (!orgId || !term) {
        setSearchResults([]);
        setIsSearching(false);
        return;
      }
      const q = buildCustomerQuery(term);
      if (!q) {
        setSearchResults([]);
        setIsSearching(false);
        return;
      }
      const myReq = ++reqCounter.current;
      setIsSearching(true);
      try {
        const res = await api.post(API_GETCUSTOMERWITHPACKAGE, {
          ORGID: orgId,
          ...q,
        });
        if (myReq !== reqCounter.current) return;
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];

        // ✅ filter ฝั่งหน้าเว็บก่อน
        const termLower = term.toLowerCase();
        const filtered = arr.filter((r) => {
          const code = String(r.cmCode || "").toLowerCase();
          const name = String(r.cmName || "").toLowerCase();
          const mobile = String(r.cmMobile || "").toLowerCase();
          const phone = String(r.cmPhone || "").toLowerCase();

          return (
            code.includes(termLower) ||
            name.includes(termLower) ||
            mobile.includes(termLower) ||
            phone.includes(termLower)
          );
        });

        const rows = filtered.map((r) => ({
          id: r.cmCode || r.id,
          code: r.cmCode || "",
          name: r.cmName || "",
          mobile: r.cmMobile || "",
          phone: r.cmPhone || "",
          subscriptions: r.subscriptions || [],
          products: r.products || [],
          raw: r,
        }));

        setSearchResults(rows.slice(0, 10));
      } catch (e) {
        if (myReq !== reqCounter.current) return;
        setSearchResults([]);
        setCusErr(e?.response?.data?.message || e?.message || "ค้นหาไม่สำเร็จ");
      } finally {
        if (reqCounter.current === myReq) setIsSearching(false);
      }
    };

    const onChange = (e) => {
      const v = e.target.value ?? "";
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => fireSearch(v), 350);
    };

    return (
      <div
        className={className}
        style={{ position: "relative", width: "100%" }}
      >
        <div className="input-group w-100">
          <input
            id={inputId}
            ref={inputRef}
            type="text"
            className="form-control"
            placeholder="รหัสลูกค้า/ชื่อ/เบอร์โทร"
            autoComplete="off"
            spellCheck={false}
            onChange={onChange}
            onCompositionStart={() => (composingRef.current = true)}
            onCompositionEnd={(e) => {
              composingRef.current = false;
              fireSearch(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          />
          <div className="input-group-append">
            <button
              type="button"
              onClick={() => setIsAddModalOpen(true)}
              className="btn"
              style={{
                backgroundColor: "#0ea5e9",
                color: "#fff",
                border: "none",
              }}
              title="เพิ่มลูกค้าใหม่"
            >
              <i className="ni ni-fat-add" />
            </button>
          </div>
        </div>

        {isSearching && (
          <div
            className="shadow"
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              marginTop: 6,
              padding: "10px 12px",
            }}
          >
            กำลังค้นหา…
          </div>
        )}

        {!isSearching && cusErr && (
          <div
            className="shadow text-danger"
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              marginTop: 6,
              padding: "10px 12px",
            }}
          >
            {cusErr}
          </div>
        )}

        {searchResults.length > 0 && !isSearching && (
          <div
            className="shadow"
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              marginTop: 6,
              overflow: "hidden",
            }}
          >
            {searchResults.map((c) => (
              <div
                key={c.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onPick(c);
                }}
                style={{
                  padding: "12px 14px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ fontWeight: 700 }}>
                  {c.code ? `${c.code} - ` : ""}
                  {c.name}
                </div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  {c.mobile || c.phone || ""}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const SearchBoxLaundry = (props) => (
    <SearchBoxBase {...props} onPick={pickCustomerLaundry} />
  );
  const SearchBoxPackage = (props) => (
    <SearchBoxBase {...props} onPick={pickCustomerPackage} />
  );

  // ===================================================================
  // L A U N D R Y
  // ===================================================================
  const [laundryServices, setLaundryServices] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [laundryLoading, setLaundryLoading] = useState(false);
  const [laundryError, setLaundryError] = useState("");

  // เก็บ services ดิบไว้สำหรับ restore
  const originalServicesRef = useRef([]);

  // ซ่อนแถบปุ่มบริการเมื่อเลือกแพ็คเกจจากโมดัล
  const [lockServiceUI, setLockServiceUI] = useState(false);

  // แพ็คเกจลูกค้าที่เลือก (จาก modal)
  const [selectedCustomerPackageInfo, setSelectedCustomerPackageInfo] =
    useState(null);

  // บริการที่เลือกจาก GetServiceWithProducts
  const selectedServiceFromAPI = useMemo(() => {
    return (
      laundryServices.find((s) => String(s.id) === String(selectedServiceId)) ||
      null
    );
  }, [laundryServices, selectedServiceId]);

  // =============================
  // ✅ PACKAGE LIMIT GUARD
  // =============================
  const getPkgLimit = () => {
    const svc = selectedServiceFromAPI;
    if (!svc) return { enabled: false };

    const limit = Number(svc.svQty || 0);
    if (!limit) return { enabled: false };

    const unit = String(svc.svUnit || "").toLowerCase();
    const type = String(svc.type || "").toLowerCase();

    const isWeight =
      unit.includes("กก") ||
      unit.includes("กิโล") ||
      unit.includes("kg") ||
      type.includes("กิโล") ||
      type.includes("ชั่ง");

    return {
      enabled: activeTab === "laundry" && laundryMode !== "perItem", // โหมดแพ็คเกจ/ชั่งกิโลเท่านั้น
      isWeight,
      limit,
      unitLabel: svc.svUnit || (isWeight ? "กิโลกรัม" : "ตัว/ชิ้น"),
      svcName: svc.name || "",
    };
  };

  const calcCurrentTotals = () => {
    // รวม qty จากฝั่งที่กำลังใช้อยู่จริง (ลูกค้า หรือ ของระบบ)
    const products = usingCustomerProducts
      ? customerProducts
      : selectedService?.products || [];

    const totalQty = (products || []).reduce(
      (sum, p) => sum + Number(p.qty || 0),
      0,
    );

    const totalWeight = (products || []).reduce((sum, p) => {
      const w = Number(p.pdWeight || 0);
      const q = Number(p.qty || 0);
      return sum + w * q;
    }, 0);

    return { totalQty, totalWeight };
  };

  const clampByPackageLimit = (pdId, desiredQty) => {
    const pkg = getPkgLimit();
    if (!pkg.enabled) return { qty: desiredQty, exceeded: false };

    const products = usingCustomerProducts
      ? customerProducts
      : selectedService?.products || [];

    const cur = (products || []).find((x) => String(x.id) === String(pdId));
    const curQty = Number(cur?.qty || 0);

    const { totalQty, totalWeight } = calcCurrentTotals();

    // ===== แบบชั่งกิโล (จำกัดด้วยน้ำหนักรวม)
    if (pkg.isWeight) {
      const w = Number(cur?.pdWeight || 0);

      // ถ้าน้ำหนักต่อชิ้นเป็น 0 → ไม่รู้จะคุมยังไง ให้ไม่ clamp แต่ยังเตือนตอนเปิดบิล
      if (!w) return { qty: desiredQty, exceeded: false };

      const curItemWeight = w * curQty;
      const otherWeight = totalWeight - curItemWeight;

      const remainWeight = pkg.limit - otherWeight;
      const maxQtyForThis = Math.max(0, Math.floor(remainWeight / w));

      const nextQty = Math.max(
        0,
        Math.min(Number(desiredQty || 0), maxQtyForThis),
      );
      const exceeded = Number(desiredQty || 0) > nextQty;

      return { qty: nextQty, exceeded };
    }

    // ===== แบบรายชิ้น (จำกัดด้วยจำนวนชิ้นรวม)
    const otherQty = totalQty - curQty;
    const maxQtyForThis = Math.max(0, pkg.limit - otherQty);

    const nextQty = Math.max(
      0,
      Math.min(Number(desiredQty || 0), maxQtyForThis),
    );
    const exceeded = Number(desiredQty || 0) > nextQty;

    return { qty: nextQty, exceeded };
  };

  const warnPackageExceeded = () => {
    const pkg = getPkgLimit();
    if (!pkg.enabled) return;

    const { totalQty, totalWeight } = calcCurrentTotals();

    if (pkg.isWeight) {
      if (Number(totalWeight) > pkg.limit) {
        sa.info(
          `น้ำหนักเกินเงื่อนไขแพ็คเกจ (${pkg.limit} ${pkg.unitLabel})`,
          "เกินโควต้าแพ็คเกจ",
        );
      }
      return;
    }

    if (Number(totalQty) > pkg.limit) {
      sa.info(
        `จำนวนชิ้นเกินเงื่อนไขแพ็คเกจ (${pkg.limit} ${pkg.unitLabel})`,
        "เกินโควต้าแพ็คเกจ",
      );
    }
  };

  // ---- เปิด modal เลือก/เปลี่ยนแพ็คเกจ ได้ทุกเมื่อ ----
  const openPackagePicker = () => {
    if (activeTab !== "laundry") return;
    if (!selectedCustomerLaundry) return sa.info("กรุณาเลือกลูกค้าก่อน");
    const subs = Array.isArray(selectedCustomerLaundry?.subscriptions)
      ? selectedCustomerLaundry.subscriptions
      : [];
    if (subs.length === 0) return sa.info("ลูกค้ายังไม่มีแพ็คเกจที่เคยซื้อ");
    setIsPkgModalOpen(true);
  };

  const cancelUsingPackage = () => {
    // ยกเลิกแพ็คเกจ -> กลับสภาพเดิม ให้เลือกบริการได้
    setSelectedCustomerPackageInfo(null);
    setLockServiceUI(false);
    restoreServiceProducts(); // รีเซ็ตบริการกลับจากต้นฉบับ (ไม่แตะ customerProducts)
  };

  // Custom items (กรอกเอง)
  const [customItems, setCustomItems] = useState([]);
  const addCustomItem = () => {
    setCustomItems((prev) => [
      ...prev,
      {
        id: `custom-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        name: "",
        price: 0,
        weight: 0,
        qty: 0,
      },
    ]);
  };
  const updateCustomName = (id, value) =>
    setCustomItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, name: value } : it)),
    );
  const updateCustomPrice = (id, value) => {
    const num = value === "" ? "" : Math.max(0, Number(value));
    setCustomItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, price: num } : it)),
    );
  };
  const updateCustomWeight = (id, value) => {
    if (value === "") {
      setCustomItems((prev) =>
        prev.map((it) => (it.id === id ? { ...it, weight: "" } : it)),
      );
      return;
    }

    const n = Math.max(0, Number(value));
    const rounded = Number(n.toFixed(2)); // ✅ บังคับ 2 ตำแหน่ง

    setCustomItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, weight: rounded } : it)),
    );
  };

  const updateCustomQty = (id, value) => {
    const num = value === "" ? "" : Math.max(0, Number(value));
    setCustomItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, qty: num } : it)),
    );
  };
  const incCustomQty = (id) =>
    setCustomItems((prev) =>
      prev.map((it) =>
        it.id === id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
      ),
    );
  const decCustomQty = (id) =>
    setCustomItems((prev) =>
      prev.map((it) =>
        it.id === id
          ? { ...it, qty: Math.max(0, Number(it.qty || 0) - 1) }
          : it,
      ),
    );

  useEffect(() => {
    const fetchServices = async () => {
      if (activeTab !== "laundry" || !orgId) return;
      setLaundryLoading(true);
      setLaundryError("");
      try {
        const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        const normalized = arr.map((s) => ({
          id: s.svId,
          name: s.svName,
          type: s.svType,
          svPrice: Number(s.svPrice ?? 0),
          svQty: Number(s.svQty ?? 0),
          svUnit: s.svUnit || "",
          products: (s.products || []).map((p) => ({
            id: p.pdId,
            name: p.pdName,
            price: Number(p.pdPrice ?? 0),
            pdWeight: Number(p.pdWeight ?? 0),
            qty: 0,
          })),
        }));
        setLaundryServices(normalized);
        originalServicesRef.current = normalized; // เก็บต้นฉบับไว้
        setSelectedServiceId(normalized[0]?.id ?? null);
      } catch (e) {
        setLaundryError(e?.message || "โหลดข้อมูลบริการไม่สำเร็จ");
      } finally {
        setLaundryLoading(false);
      }
    };
    fetchServices();
  }, [activeTab, orgId]);

  const displayLaundryServices = useMemo(() => {
    if (lockServiceUI) return laundryServices; // ✅ สำคัญ

    const t = (x) =>
      String(x?.type || "")
        .toLowerCase()
        .trim();

    switch (laundryMode) {
      case "byWeight":
        return laundryServices.filter(
          (s) => t(s).includes("กิโล") || t(s).includes("ชั่ง"),
        );
      case "package":
        return laundryServices.filter((s) => t(s).includes("แพ็คเกจ"));
      default:
        return laundryServices.filter((s) => {
          const tt = t(s);
          if (!tt) return true;
          return (
            tt.includes("รายชิ้น") &&
            !tt.includes("แพ็คเกจ") &&
            !tt.includes("กิโล") &&
            !tt.includes("ชั่ง")
          );
        });
    }
  }, [laundryServices, laundryMode, lockServiceUI]);

  useEffect(() => {
    if (activeTab !== "laundry") return;
    if (lockServiceUI) return; // ✅ อย่า auto-reset ตอน lock

    if (!displayLaundryServices.find((s) => s.id === selectedServiceId)) {
      setSelectedServiceId(displayLaundryServices[0]?.id ?? null);
    }
  }, [activeTab, displayLaundryServices, selectedServiceId, lockServiceUI]);

  const selectedService = useMemo(
    () => laundryServices.find((s) => s.id === selectedServiceId) || null,
    [laundryServices, selectedServiceId],
  );

  // ชื่อแพ็คเกจ/บริการที่เลือกปัจจุบัน
  const currentPackageName = useMemo(() => {
    if (selectedCustomerPackageInfo?.name)
      return selectedCustomerPackageInfo.name;
    if (selectedService?.name) return selectedService.name;
    return "";
  }, [selectedCustomerPackageInfo, selectedService]);

  // ✅ โหมดแสดงสินค้า: ลูกค้ามีสินค้า และยังไม่ได้ lock จากแพ็คเกจ
  const usingCustomerProducts =
    activeTab === "laundry" &&
    allowCustomerProducts &&
    Array.isArray(customerProducts) &&
    customerProducts.length > 0;

  const updateQtyLaundry = (pdId, value) => {
    const raw = value === "" ? "" : Math.max(0, Number(value));
    if (raw === "") {
      // อนุญาตให้พิมพ์ว่างชั่วคราว
      if (usingCustomerProducts) {
        setCustomerProducts((prev) =>
          prev.map((p) =>
            String(p.id) === String(pdId) ? { ...p, qty: "" } : p,
          ),
        );
      } else {
        setLaundryServices((prev) =>
          prev.map((svc) =>
            svc.id !== selectedServiceId
              ? svc
              : {
                  ...svc,
                  products: svc.products.map((p) =>
                    String(p.id) === String(pdId) ? { ...p, qty: "" } : p,
                  ),
                },
          ),
        );
      }
      return;
    }

    const { qty: clampedQty, exceeded } = clampByPackageLimit(pdId, raw);
    if (exceeded) warnPackageExceeded();

    if (usingCustomerProducts) {
      setCustomerProducts((prev) =>
        prev.map((p) =>
          String(p.id) === String(pdId) ? { ...p, qty: clampedQty } : p,
        ),
      );
      return;
    }

    setLaundryServices((prev) =>
      prev.map((svc) =>
        svc.id !== selectedServiceId
          ? svc
          : {
              ...svc,
              products: svc.products.map((p) =>
                String(p.id) === String(pdId) ? { ...p, qty: clampedQty } : p,
              ),
            },
      ),
    );
  };

  const incQtyLaundry = (pdId) => {
    const products = usingCustomerProducts
      ? customerProducts
      : selectedService?.products || [];
    const cur = (products || []).find((x) => String(x.id) === String(pdId));
    const rawNext = Number(cur?.qty || 0) + 1;

    const { qty: clampedQty, exceeded } = clampByPackageLimit(pdId, rawNext);
    if (exceeded) {
      warnPackageExceeded();
      return; // กันไม่ให้ + เกิน
    }

    if (usingCustomerProducts) {
      setCustomerProducts((prev) =>
        prev.map((p) =>
          String(p.id) === String(pdId) ? { ...p, qty: clampedQty } : p,
        ),
      );
      return;
    }

    setLaundryServices((prev) =>
      prev.map((svc) =>
        svc.id !== selectedServiceId
          ? svc
          : {
              ...svc,
              products: svc.products.map((p) =>
                String(p.id) === String(pdId) ? { ...p, qty: clampedQty } : p,
              ),
            },
      ),
    );
  };

  const decQtyLaundry = (pdId) => {
    if (usingCustomerProducts) {
      setCustomerProducts((prev) =>
        prev.map((p) =>
          String(p.id) === String(pdId)
            ? { ...p, qty: Math.max(0, Number(p.qty || 0) - 1) }
            : p,
        ),
      );
      return;
    }

    setLaundryServices((prev) =>
      prev.map((svc) =>
        svc.id !== selectedServiceId
          ? svc
          : {
              ...svc,
              products: svc.products.map((p) =>
                p.id === pdId
                  ? { ...p, qty: Math.max(0, Number(p.qty || 0) - 1) }
                  : p,
              ),
            },
      ),
    );
  };

  const cartLaundry = useMemo(() => {
    const items = [];

    // ✅ ถ้าใช้สินค้าลูกค้า -> เอาจาก customerProducts อย่างเดียว
    if (usingCustomerProducts) {
      (customerProducts || []).forEach((p) => {
        if (Number(p.qty) > 0) {
          items.push({
            id: `cust:${p.id}`,
            name: `${p.name}`,
            price: Number(p.price || 0),
            qty: Number(p.qty),
            pdWeight: Number(p.pdWeight || 0),
          });
        }
      });
    } else {
      // ✅ ของระบบเดิม
      laundryServices.forEach((svc) =>
        svc.products.forEach((p) => {
          if (Number(p.qty) > 0) {
            items.push({
              id: `${svc.id}:${p.id}`,
              name: `${p.name}`,
              price: p.price,
              qty: Number(p.qty),
              pdWeight: Number(p.pdWeight || 0),
            });
          }
        }),
      );
    }

    customItems.forEach((c) => {
      if (Number(c.qty) > 0) {
        items.push({
          id: c.id,
          name: c.name || "รายการ (กรอกเอง)",
          price: Number(c.price || 0),
          qty: Number(c.qty),
          pdWeight: Number(c.weight || 0),
        });
      }
    });

    return items;
  }, [laundryServices, customItems, usingCustomerProducts, customerProducts]);

  const totalLaundry = useMemo(
    () => cartLaundry.reduce((s, p) => s + p.price * p.qty, 0),
    [cartLaundry],
  );

  const totalPdWeight = useMemo(() => {
    // คิดเฉพาะสินค้าที่มี pdWeight (custom ไม่มี)
    return cartLaundry.reduce((sum, it) => {
      const w = Number(it.pdWeight || 0);
      const q = Number(it.qty || 0);
      return sum + w * q;
    }, 0);
  }, [cartLaundry]);

  const handleSelectService = (id) => {
    if (id === selectedServiceId) return;

    // ✅ เปลี่ยนบริการแล้ว: เคลียร์ qty ของสินค้าลูกค้า (กันปน) แต่ไม่ลบรายการลูกค้า
    setCustomerProducts((prev) => prev.map((p) => ({ ...p, qty: 0 })));

    // reset qty ทุก service เพื่อไม่ให้ปนกัน
    setLaundryServices((prev) =>
      prev.map((svc) => ({
        ...svc,
        products: svc.products.map((p) => ({ ...p, qty: 0 })),
      })),
    );
    setSelectedServiceId(id);
  };

  // ✅ รายการสินค้าในหน้าซ้าย (โชว์ลูกค้า ถ้ามี / ไม่งั้นโชว์ของระบบ)
  const productsAll = usingCustomerProducts
    ? customerProducts
    : selectedService?.products || [];

  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) listRef.current.scrollTop = 0;
  }, [selectedServiceId, laundryMode, lockServiceUI, usingCustomerProducts]);

  // ===================================================================
  // P A C K A G E
  // ===================================================================
  const [servicePkgs, setServicePkgs] = useState([]);
  const [cartPackage, setCartPackage] = useState([]);
  const [spLoading, setSpLoading] = useState(false);
  const [spError, setSpError] = useState("");
  const [paying, setPaying] = useState(false);
  const [payResult, setPayResult] = useState(null);

  const syncCartPackage = (rows) =>
    setCartPackage(
      rows
        .filter((p) => Number(p.qty) > 0)
        .map((p) => ({
          id: p.id,
          name: p.name,
          price: p.price,
          qty: Number(p.qty),
        })),
    );

  const updateQtyPkg = (id, value) => {
    const num = value === "" ? "" : Math.max(0, Number(value));
    setServicePkgs((prev) => {
      const next = prev.map((it) => (it.id === id ? { ...it, qty: num } : it));
      syncCartPackage(next);
      return next;
    });
  };
  const incQtyPkg = (id) =>
    setServicePkgs((prev) => {
      const next = prev.map((it) =>
        it.id === id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
      );
      syncCartPackage(next);
      return next;
    });
  const decQtyPkg = (id) =>
    setServicePkgs((prev) => {
      const next = prev.map((it) =>
        it.id === id
          ? { ...it, qty: Math.max(0, Number(it.qty || 0) - 1) }
          : it,
      );
      syncCartPackage(next);
      return next;
    });

  const totalPackage = useMemo(
    () => cartPackage.reduce((s, p) => s + p.price * p.qty, 0),
    [cartPackage],
  );

  useEffect(() => {
    const fetchPkgs = async () => {
      if (activeTab !== "package" || !orgId) return;
      setSpLoading(true);
      setSpError("");
      try {
        const res = await api.get(API_GETSERVICEPACKAGES, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        const normalized = arr.map((x) => ({
          id: x.svId,
          code: x.svCode,
          name: x.svName,
          price: Number(x.svPrice ?? 0),
          unit: x.svUnit || "ครั้ง",
          qty: x.svQty,
          leadtime: Number(x.svLeadTime ?? 0),
          type: x.svType,
        }));
        setServicePkgs(normalized);
        setCartPackage([]);
      } catch (e) {
        setSpError(e?.message || "โหลดแพ็คเกจไม่สำเร็จ");
      } finally {
        setSpLoading(false);
      }
    };
    fetchPkgs();
  }, [activeTab, orgId]);

  const addPkgToCart = (pkg) => {
    setCartPackage((prev) => {
      const found = prev.find((it) => it.id === pkg.id);
      if (found) {
        return prev.map((it) =>
          it.id === pkg.id ? { ...it, qty: Number(it.qty || 0) + 1 } : it,
        );
      }
      return [
        ...prev,
        { id: pkg.id, name: pkg.name, price: pkg.price, qty: 1 },
      ];
    });
  };

  const fetchCustomerWithPackageByCode = async (cmCode) => {
    const res = await api.post(API_GETCUSTOMERWITHPACKAGE, {
      ORGID: orgId,
      CMCODE: cmCode,
    });
    const row = Array.isArray(res?.data?.data) ? res.data.data[0] : null;
    if (!row) return null;
    return {
      id: row.cmCode || row.id,
      code: row.cmCode || "",
      name: row.cmName || "",
      mobile: row.cmMobile || "",
      phone: row.cmPhone || "",
      subscriptions: row.subscriptions || [],
      products: row.products || [],
      raw: row,
    };
  };

  const handlePayPackages = async () => {
    if (!orgId) return sa.error("ไม่พบ ORGID");
    if (!selectedCustomerPackage?.code)
      return sa.info("กรุณาเลือกลูกค้าในแท็บ 'ซื้อแพ็คเกจ' ก่อนทำรายการ");
    if (cartPackage.length === 0) return sa.info("ยังไม่มีแพ็คเกจในตะกร้า");

    // แปลง cart → ITEMS
    const ITEMS = [];
    cartPackage.forEach((p) => {
      const n = Math.max(1, Number(p.qty || 0));
      for (let i = 0; i < n; i += 1) ITEMS.push({ SVID: p.id });
    });

    const payload = {
      ORGID: orgId,
      ITEMS,
      CMCODE: selectedCustomerPackage.code,
    };

    try {
      setPaying(true);
      setPayResult(null);

      const res = await api.post(API_BUYSERVICEPACKAGE, payload);
      const ok = res?.data?.statustext === "SUCCESS";
      setPayResult(res?.data || null);

      if (!ok) {
        console.error("BuyServicePackage error:", res?.data);
        return sa.error(res?.data?.message || "ทำรายการไม่สำเร็จ");
      }

      setCartPackage([]);

      // รีเฟรชเครดิตลูกค้า แล้วอัปเดตทั้งสองฝั่ง
      const refreshed = await fetchCustomerWithPackageByCode(
        selectedCustomerPackage.code,
      );
      if (refreshed) {
        setSelectedCustomerLaundry(refreshed);
        setSelectedCustomerPackage(refreshed);

        // ✅ รีเฟรชสินค้าลูกค้าในฝั่งเปิดบิลด้วย (กรณีลูกค้ามีสินค้า)
        setCustomerProductsFromCus(refreshed);
      }

      await sa.success(res?.data?.message || "ซื้อ Subscription สำเร็จ!");
    } catch (e) {
      console.error("BuyServicePackage exception:", e);
      sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
    } finally {
      setPaying(false);
    }
  };

  // ลบรายการในตะกร้าเปิดบิล
  const removeLaundryItem = (item) => {
    if (String(item.id).startsWith("custom-")) {
      setCustomItems((prev) => prev.filter((x) => x.id !== item.id));
      return;
    }

    // ✅ ถ้าเป็นสินค้าลูกค้า
    if (String(item.id).startsWith("cust:")) {
      const pdId = String(item.id).split(":")[1];
      setCustomerProducts((prev) =>
        prev.map((p) => (String(p.id) === String(pdId) ? { ...p, qty: 0 } : p)),
      );
      return;
    }

    // ✅ ของระบบเดิม
    const [svId, pdId] = String(item.id).split(":");
    setLaundryServices((prev) =>
      prev.map((svc) =>
        String(svc.id) !== String(svId)
          ? svc
          : {
              ...svc,
              products: svc.products.map((p) =>
                String(p.id) === String(pdId) ? { ...p, qty: 0 } : p,
              ),
            },
      ),
    );
  };

  // ลบรายการในตะกร้าแพ็คเกจ
  const removePackageItem = (id) => {
    setCartPackage((prev) => prev.filter((x) => x.id !== id));
    setServicePkgs((prev) =>
      prev.map((it) => (it.id === id ? { ...it, qty: 0 } : it)),
    );
  };

  // ช่วยตีความโหมดจาก type (จาก API)
  const getModeFromType = (type) => {
    const t = String(type || "").toLowerCase();
    if (t.includes("กิโล") || t.includes("ชั่ง")) return "byWeight";
    if (t.includes("แพ็คเกจ")) return "package";
    return "perItem";
  };

  // หาโหมดที่ถูกต้องจาก svId ใน services เดิม
  const resolveModeForService = (svId) => {
    const svc = (originalServicesRef.current || []).find(
      (s) => String(s.id) === String(svId),
    );
    return getModeFromType(svc?.type);
  };

  const restoreServiceProducts = () => {
    const original = originalServicesRef.current || [];
    setLaundryServices(
      original.map((s) => ({
        ...s,
        products: (s.products || []).map((p) => ({ ...p, qty: 0 })),
      })),
    );
    setLaundryMode("perItem");
    setSelectedServiceId(original[0]?.id ?? null);
    setSelectedCustomerPackageInfo(null);
    setLockServiceUI(false);
  };

  // ===================================================================
  // เปิดบิล
  // ===================================================================
  const [isBillModalOpen, setIsBillModalOpen] = useState(false);
  const [receiveDate, setReceiveDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [creatingBill, setCreatingBill] = useState(false);

  const openBillModal = () => {
    if (!selectedCustomerLaundry?.code) {
      return sa.info("กรุณาเลือกลูกค้าในแท็บ 'เปิดบิล' ก่อนทำรายการ");
    }
    if (cartLaundry.length === 0) {
      return sa.info("ยังไม่มีรายการในตะกร้า");
    }

    // ตั้งค่า default วันที่รับ/ส่ง
    const toDateInput = (d) => d.toISOString().slice(0, 10);
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    setReceiveDate(toDateInput(today));
    setDueDate(toDateInput(tomorrow));

    // ✅ กันเปิดบิลถ้าเกินเงื่อนไขแพ็คเกจ
    const pkg = getPkgLimit();
    if (pkg.enabled) {
      const { totalQty, totalWeight } = calcCurrentTotals();
      if (pkg.isWeight && Number(totalWeight) > pkg.limit) {
        sa.info(
          `น้ำหนักเกินเงื่อนไขแพ็คเกจ (${pkg.limit} ${pkg.unitLabel})`,
          "เกินโควต้าแพ็คเกจ",
        );
        return;
      }
      if (!pkg.isWeight && Number(totalQty) > pkg.limit) {
        sa.info(
          `จำนวนชิ้นเกินเงื่อนไขแพ็คเกจ (${pkg.limit} ${pkg.unitLabel})`,
          "เกินโควต้าแพ็คเกจ",
        );
        return;
      }
    }

    setIsBillModalOpen(true);
  };

  const addProductFromCustomItem = async (it) => {
    if (!orgId || !tnId) throw new Error("Missing ORGID/TNID");

    // ถ้า API_ADDPRODUCT รับเป็น JSON:
    const payload = {
      TNID: tnId,
      ORGID: orgId,
      BRID: brId,
      CMCODE: selectedCustomerLaundry.code,
      NAME: (it.name || "").trim() || "รายการ (กรอกเอง)",
      PDPRICE: Number(it.price || 0),
      WEIGHT: Number(it.weight || 0),
    };

    const res = await api.post(API_ADDPRODUCT, payload);
    const ok = res?.data?.statustext === "SUCCESS";
    if (!ok) throw new Error(res?.data?.message || "AddProduct failed");

    // ✅ ปรับทางอ่าน pdId ให้ตรง response จริงของคุณ
    const pdId = res?.data?.data?.[0]?.pdId || null;

    if (!pdId) throw new Error("API_ADDPRODUCT did not return pdId");
    return pdId;
  };

  // 1) เพิ่ม helper เช็คแพ็คเกจก่อน (วางไว้เหนือ handleSaveBill ได้เลย)
  const hasSubForService = (subs, svId) => {
    const list = Array.isArray(subs) ? subs : [];
    const targetId = String(svId ?? "");

    return list.some((s) => {
      const same = String(s?.svId ?? "") === targetId;

      // จะเช็คแค่ svId ตรง "พอ" ตามที่คุณขอ
      // (ถ้าคุณอยากเข้มขึ้น ค่อยเพิ่มเงื่อนไข status/remaining ได้)
      return same;
    });
  };

  const handleSaveBill = async () => {
    if (!orgId) return sa.error("ไม่พบ ORGID");
    if (!receiveDate || !dueDate)
      return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");

    try {
      setCreatingBill(true);

      // 1) ITEMS จากของเดิม (customer/system) เหมือนเดิม
      const ITEMS = [];

      cartLaundry.forEach((item) => {
        if (String(item.id).startsWith("custom-")) return; // ✅ เดี๋ยวจัดการทีหลัง

        if (String(item.id).startsWith("cust:")) {
          const pdId = String(item.id).split(":")[1];
          if (!pdId) return;
          ITEMS.push({
            pdId,
            bdQty: Number(item.qty || 0),
            pdPrice: Number(item.price || 0),
          });
          return;
        }

        const [, pdId] = String(item.id).split(":");
        if (!pdId) return;
        ITEMS.push({
          pdId,
          bdQty: Number(item.qty || 0),
          pdPrice: Number(item.price || 0),
        });
      });

      // 2) ยิง API_ADDPRODUCT สำหรับ custom items แล้วเอา pdId ใส่ ITEMS
      const customToCreate = (customItems || []).filter(
        (it) => Number(it.qty || 0) > 0,
      );

      for (const it of customToCreate) {
        const pdId = await addProductFromCustomItem(it);
        ITEMS.push({
          pdId,
          bdQty: Number(it.qty || 0),
          pdPrice: Number(it.price || 0),
        });
      }

      if (ITEMS.length === 0)
        return sa.info("ไม่พบรายการสินค้าที่สามารถเปิดบิลได้");

      const totalQty = ITEMS.reduce(
        (sum, it) => sum + Number(it.bdQty || 0),
        0,
      );

      // ✅ ถ้าลูกค้ายังไม่มีแพ็คเกจ -> ซื้อแพ็คเกจให้ก่อน
      // ✅ เงื่อนไขซื้อแพ็คเกจอัตโนมัติ ตอนเปิดบิล
      const subs = Array.isArray(selectedCustomerLaundry?.subscriptions)
        ? selectedCustomerLaundry.subscriptions
        : [];

      // 1) ถ้า "รายชิ้น" ห้ามซื้อแพ็คเกจอัตโนมัติ
      const shouldAutoBuyPackage = laundryMode !== "perItem";

      if (shouldAutoBuyPackage) {
        // 2) เช็คว่ามี subscription svId ตรงกับบริการที่เลือกหรือยัง
        const matched = hasSubForService(subs, selectedServiceId);

        // 3) ถ้าไม่ตรง -> ซื้อแพ็คเกจนั้นให้เลย
        if (!matched) {
          const buyPayload = {
            ORGID: orgId,
            CMCODE: selectedCustomerLaundry.code,
            ITEMS: [{ SVID: selectedServiceId }],
          };

          const buyRes = await api.post(API_BUYSERVICEPACKAGE, buyPayload);
          const buyOk = buyRes?.data?.statustext === "SUCCESS";
          if (!buyOk) {
            return sa.error(
              buyRes?.data?.message || "ซื้อแพ็คเกจก่อนเปิดบิลไม่สำเร็จ",
            );
          }

          // ✅ รีเฟรช customer เพื่อให้ subscriptions อัปเดตล่าสุด
          const refreshed = await fetchCustomerWithPackageByCode(
            selectedCustomerLaundry.code,
          );
          if (refreshed) {
            setSelectedCustomerLaundry(refreshed);
            setSelectedCustomerPackage(refreshed);
            setCustomerProductsFromCus(refreshed);
          }
        }
      }

      // 3) ค่อยยิง API_CREATEBILL
      const payload = {
        TNID: tnId,
        ORGID: orgId,
        BRID: brId,
        CMCODE: selectedCustomerLaundry.code,
        SVID: selectedServiceId,
        BRECEIVE: receiveDate,
        BDUEDATE: dueDate,
        DISCOUNT: 0,
        VAT: 0,
        TOTALPDWEIGHT: Number(totalPdWeight || 0),
        TOTALQTY: Number(totalQty || 0),
        ITEMS,
      };

      const res = await api.post(API_CREATEBILL, payload);
      const ok = res?.data?.statustext === "SUCCESS";
      if (!ok) return sa.error(res?.data?.message || "เปิดบิลไม่สำเร็จ");

      // เคลียร์ตะกร้า
      setLaundryServices((prev) =>
        prev.map((svc) => ({
          ...svc,
          products: svc.products.map((p) => ({ ...p, qty: 0 })),
        })),
      );
      setCustomerProducts((prev) => prev.map((p) => ({ ...p, qty: 0 })));
      setCustomItems([]);
      setIsBillModalOpen(false);

      sa.success(res?.data?.message || "เปิดบิลสำเร็จ");
    } catch (e) {
      console.error("SaveBill error:", e);
      sa.error(e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด");
    } finally {
      setCreatingBill(false);
    }
  };

  const handleAddCustomerSubmit = async (e) => {
    e.preventDefault();
    if (submittingCustomer) return;

    try {
      if (!orgId || !tnId) {
        return sa.error("ไม่พบข้อมูลองค์กรหรือเทนแนนต์ (ORGID/TNID)");
      }

      if (!customerForm.cmName.trim()) {
        return sa.info("กรุณากรอกชื่อ/ชื่อลูกค้า");
      }

      if (!customerForm.cmMobile.trim()) {
        return sa.info("กรุณากรอกเบอร์โทร");
      }

      setSubmittingCustomer(true);

      const safeDigits = (v = "") => String(v).replace(/[^0-9]/g, "");
      const fd = new FormData();

      appendStr(fd, "TNID", tnId);
      appendStr(fd, "ORGID", orgId);

      const CMTYPE_LABEL =
        customerType === "individual" ? "บุคคลธรรมดา" : "นิติบุคคล";
      appendStr(fd, "CMTYPE", CMTYPE_LABEL);

      // ฟอร์มแบบง่าย: เน้น CMNAME + CMMOBILE ส่วนอื่นๆ ว่างไว้
      appendStr(fd, "CMNAME", customerForm.cmName.trim());
      appendStr(fd, "CMMOBILE", safeDigits(customerForm.cmMobile));

      appendStr(fd, "CMADDR", "");
      appendStr(fd, "CMSUBDISTRICT", "");
      appendStr(fd, "CMDISTRICT", "");
      appendStr(fd, "CMPROVINCE", "");
      appendStr(fd, "CMZIPCODE", "");

      appendStr(fd, "CMBILLNAMETH", "");
      appendStr(fd, "CMBILLNAMEEN", "");
      appendStr(fd, "CBID", "");
      appendStr(fd, "CMTAXID", "");
      appendStr(fd, "CMEMAIL", "");
      appendStr(fd, "CMADDR2", "");
      appendStr(fd, "CMBILLADDR", "");
      appendStr(fd, "CMBILLADDR2", "");
      appendStr(fd, "CMBILLSUBDISTRICT", "");
      appendStr(fd, "CMBILLDISTRICT", "");
      appendStr(fd, "CMBILLPROVINCE", "");
      appendStr(fd, "CMBILLZIPCODE", "");
      appendStr(fd, "CMBILLMOBILE", "");
      appendStr(fd, "CMBILLEMAIL", "");
      appendStr(fd, "CMCONTACTNAME", "");
      appendStr(fd, "CMCONTACTMOBILE", "");

      const res = await api.post(API_ADDCUSTOMER, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      await sa.success(res?.data?.message || "เพิ่มลูกค้าสำเร็จ");

      setCustomerForm({ cmName: "", cmMobile: "" });
      setIsAddModalOpen(false);
    } catch (err) {
      console.error("AddCustomer error:", err);
      sa.error(
        err?.response?.data?.message || err?.message || "เพิ่มลูกค้าไม่สำเร็จ",
      );
    } finally {
      setSubmittingCustomer(false);
    }
  };

  return (
    <>
      <style>{`
  /* ===== MODE SWITCH ===== */
  .mode-switch {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
  }
  .mode-pill, .svc-btn {
    font-size: .75rem;
    font-weight: 600;
    height: 37px;
    line-height: 1.1;
  }
  .mode-pill {
    border-radius: 999px;
    padding: 6px 14px;
    border: 1px solid rgba(0,0,0,.06);
    background: #fff;
    color: #0f172a;
    box-shadow: 0 3px 8px rgba(2,119,189,.08);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mode-pill.active {
    background: #1171ef;
    color: #fff;
    border-color: transparent;
    box-shadow: 0 4px 12px rgba(17,113,239,.25);
  }

  /* ===== SERVICE GRID ===== */
.svc-grid{
  display: grid;
  gap: 12px;
  justify-content: start;   /* ✅ ชิดซ้าย ไม่กระจาย */
  align-items: center;

  /* ค่าเริ่มต้น (จอเล็ก) */
  grid-template-columns: repeat(2, 180px);
}

.svc-btn{
  width: 180px;            /* ✅ ไม่ยืด */
  height: 37px;
  border-radius: 9999px;
  padding: 0 10px;

  display:flex;
  align-items:center;
  justify-content:center;

  font-size:.75rem;
  font-weight:600;
  line-height:1.1;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.svc-btn .sub{
  font-size: 10px;
  opacity: .85;
  margin-left: 6px;
}

  /* ===== ITEM ROW ===== */
  .item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0,0,0,.06);
    gap: 12px;
  }
  .qty {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .btn-qty {
    width: 38px;
    height: 38px;
    border-radius: 10px;
  }
  .qty-input {
    width: 80px;
    text-align: center;
  }
  .unit {
    margin-left: 6px;
    color: #64748b;
    white-space: nowrap;
  }

  /* ===== PAGING ===== */
  .paging-wrap {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
  }
  .paging-btn {
    min-width: 34px;
    height: 34px;
    padding: 0 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
  }
  .paging-btn.active {
    background: #1171ef;
    color: #fff;
    border-color: #1171ef;
  }
  .paging-btn.icon {
    font-weight: 700;
  }

  /* ===== SUBSCRIPTION CARD GRID ===== */
  .subs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
    gap: 10px;
  }
  .subs-card {
    border-radius: 14px;
    background: #f8fafc;
    color: #0f172a;
    border: 1px solid #e5e7eb;
    padding: 12px 10px;
  }
    
  /* ===== Navbar / Dropdown ให้อยู่บนสุด ===== */
  .navbar-top,
  #navbar-main {
    z-index: 2000 !important;      
  }

  .navbar-top .dropdown-menu,
  #navbar-main .dropdown-menu {
    position: absolute !important;
    z-index: 2100 !important;  /* สูงกว่าปุ่ม + ทั้งหมด */
  }

  /* ตะกร้าอย่าไปสร้าง z-index แข่งกับ navbar */
  .cart-sticky {
    z-index: auto !important;
  }

  /* แสดงพร้อมกันสูงสุด 5 แถว แล้วเลื่อนขึ้นลง */
.product-scroll{
  overflow-y: auto;
  max-height: calc(5 * 62px); /* ปรับ 62px ให้พอดีกับความสูง 1 แถวของ item-row */
  padding-right: 6px;
}

/* (optional) ทำ scrollbar ดูเนียนขึ้น */
.product-scroll::-webkit-scrollbar{ width: 8px; }
.product-scroll::-webkit-scrollbar-thumb{ background: rgba(148,163,184,.7); border-radius: 999px; }
.product-scroll::-webkit-scrollbar-track{ background: rgba(226,232,240,.6); border-radius: 999px; }

/* ===== SERVICE BUTTON : NOT ACTIVE ===== */
.svc-btn.btn-outline-secondary{
  border-width: 2px;                 /* ✅ หนาขึ้น */
  border-color: #94a3b8;              /* slate-400 */
  background-color: #fff;
  color: #334155;                     /* slate-700 */
}

/* hover ของปุ่มไม่ active */
.svc-btn.btn-outline-secondary:hover{
  border-color: #64748b;              /* slate-500 */
  background-color: #f8fafc;
  color: #1e293b;
}

/* ===== SERVICE BUTTON : ACTIVE ===== */
.svc-btn.btn-primary{
  border-width: 0;                    /* active ไม่มีเส้น */
}

/* ===== SERVICE GRID (LOCK 5 COL / 2 COL) ===== */
.svc-grid{
  display: grid;
  gap: 12px;
  justify-content: start;     /* ชิดซ้าย */
  width: fit-content;         /* ✅ ทำให้ grid หดตามความกว้างจริง ไม่เกิดช่องว่าง */
  max-width: 100%;
}

/* จอเล็ก: 2 ปุ่ม */
@media (max-width: 767.98px){
  .svc-grid{
    grid-template-columns: repeat(2, 140px);
  }
}

/* จอกลาง+ใหญ่: 4 ปุ่ม */
@media (min-width: 768px){
  .svc-grid{
    grid-template-columns: repeat(5, 180px);
  }
}

/* ปุ่ม */
.svc-btn{
  width: 180px;
  height: 37px;
  border-radius: 9999px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.add-detail-fab{
position: fixed;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: none;
  background: #1171ef;
  color: #fff;
  box-shadow: 0 10px 25px rgba(17,113,239,.35);
  z-index: 1200;
}
.add-detail-fab i{ font-size: 22px; }


`}</style>

      <div className="order-page">
        <Header />
        <Container className="mt--7" fluid>
          <Card>
            <CardHeader
              className="bg-white border-0"
              style={{ padding: "1.25rem 1.5rem" }}
            >
              <Row className="align-items-center">
                <Col xs="12" lg="6">
                  <h6 className="mb-0">เปิดบิล</h6>
                </Col>
                <Col xs="12" lg="6" className="mt-3 mt-lg-0">
                  <div className="d-flex justify-content-lg-end">
                    <div className="w-100 w-lg-2/3">
                      <label
                        htmlFor="customer-search"
                        className="form-label mb-1"
                        style={{ fontWeight: 600, color: "#334155" }}
                      >
                        ค้นหาลูกค้า
                      </label>
                      {activeTab === "laundry" ? (
                        <SearchBoxLaundry inputId="customer-search-laundry" />
                      ) : (
                        <SearchBoxPackage inputId="customer-search-package" />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </CardHeader>

            <Nav tabs className="mt-3">
              <NavItem>
                <NavLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("laundry");
                  }}
                  className={activeTab === "laundry" ? "active" : ""}
                >
                  เปิดบิล
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("package");
                  }}
                  className={activeTab === "package" ? "active" : ""}
                >
                  ซื้อแพ็คเกจ
                </NavLink>
              </NavItem>
            </Nav>

            <CardBody
              className="border-0 p-2 p-lg-4"
              style={{ backgroundColor: "#f7f9fb" }}
            >
              <Row className="g-0 g-lg-4 px-0 px-lg-3">
                {/* Middle */}
                <Col xs="12" md="12" lg={8} className="mb-3 px-0 px-lg-2">
                  <Card className="shadow-sm h-100">
                    <CardBody style={{ padding: "1rem" }}>
                      {/* ===== โหมดย่อย + ปุ่มบริการ (ซ่อนถ้า lockServiceUI=true) ===== */}
                      {activeTab === "laundry" && (
                        <>
                          <Nav tabs className="mb-3">
                            <NavItem>
                              <NavLink
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (lockServiceUI) return;
                                  setLaundryMode("perItem");
                                  setSelectedServiceId(null);
                                }}
                                className={
                                  laundryMode === "perItem" ? "active" : ""
                                }
                              >
                                รายชิ้น
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (lockServiceUI) return;
                                  setLaundryMode("package");
                                  setSelectedServiceId(null);
                                }}
                                className={
                                  laundryMode === "package" ? "active" : ""
                                }
                              >
                                แพ็คเกจ
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (lockServiceUI) return;
                                  setLaundryMode("byWeight");
                                  setSelectedServiceId(null);
                                }}
                                className={
                                  laundryMode === "byWeight" ? "active" : ""
                                }
                              >
                                ชั่งกิโล
                              </NavLink>
                            </NavItem>
                          </Nav>

                          {/* ===== แถบเปลี่ยนแพ็คเกจ (กดได้ตลอด) ===== */}
                          {selectedCustomerLaundry && (
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div style={{ fontSize: 14, color: "#0f172a" }}>
                                {selectedCustomerPackageInfo?.name && (
                                  <>
                                    แพ็คเกจที่เลือก:{" "}
                                    <strong>
                                      {selectedCustomerPackageInfo.name}
                                    </strong>
                                  </>
                                )}
                              </div>

                              <div className="d-flex" style={{ gap: 1 }}>
                                {selectedCustomerPackageInfo && (
                                  <Button
                                    size="sm"
                                    color="danger"
                                    outline
                                    className="rounded-pill"
                                    onClick={cancelUsingPackage}
                                  >
                                    ไม่ใช้แพ็คเกจนี้
                                  </Button>
                                )}
                                <Button
                                  size="sm"
                                  color="primary"
                                  outline
                                  className="rounded-pill"
                                  onClick={openPackagePicker}
                                >
                                  แพ็คเกจที่เคยซื้อ
                                </Button>
                              </div>
                            </div>
                          )}

                          {!lockServiceUI && (
                            <div className="mb-4">
                              <div className="svc-grid">
                                {laundryLoading && (
                                  <span className="text-muted">
                                    กำลังโหลดบริการ...
                                  </span>
                                )}
                                {!laundryLoading && laundryError && (
                                  <span className="text-danger">
                                    {laundryError}
                                  </span>
                                )}
                                {!laundryLoading &&
                                  !laundryError &&
                                  displayLaundryServices.map((svc) => {
                                    const active = selectedServiceId === svc.id;
                                    return (
                                      <Button
                                        key={svc.id}
                                        size="sm"
                                        outline={!active}
                                        color={active ? "primary" : "secondary"}
                                        className="svc-btn"
                                        onClick={() => {
                                          handleSelectService(svc.id);
                                        }}
                                        aria-pressed={active}
                                      >
                                        <span className="main">{svc.name}</span>
                                        <span className="sub">
                                          ({svc.type || "รายชิ้น"})
                                        </span>
                                      </Button>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {/* ================= Laundry: รายสินค้า ================= */}
                      {activeTab === "laundry" && (
                        <>
                          <div ref={listRef} className="product-scroll">
                            {productsAll.map((p) => (
                              <div key={p.id} className="item-row">
                                <div style={{ fontWeight: 500 }}>
                                  {p.name}{" "}
                                  {p.pdWeight !== undefined &&
                                  p.pdWeight !== null &&
                                  Number(p.pdWeight) > 0
                                    ? ` (${Number(p.pdWeight).toFixed(2)} กก.)`
                                    : ""}
                                </div>

                                <div className="qty">
                                  <span className="unit">จำนวนผ้า</span>
                                  <Button
                                    color="light"
                                    onClick={() => decQtyLaundry(p.id)}
                                    className="btn-qty"
                                  >
                                    –
                                  </Button>

                                  <Input
                                    type="number"
                                    min="0"
                                    value={p.qty === "" ? "" : Number(p.qty)}
                                    onChange={(e) =>
                                      updateQtyLaundry(p.id, e.target.value)
                                    }
                                    className="qty-input"
                                  />

                                  <Button
                                    onClick={() => incQtyLaundry(p.id)}
                                    className="btn-qty"
                                    style={{
                                      backgroundColor: "#1171ef",
                                      color: "#fff",
                                      border: "none",
                                    }}
                                  >
                                    +
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>

                          {customItems.map((it) => (
                            <div key={it.id} className="item-row custom-item">
                              <div className="custom-name">
                                <Input
                                  type="text"
                                  placeholder="พิมพ์ชื่อสินค้า"
                                  value={it.name}
                                  onChange={(e) =>
                                    updateCustomName(it.id, e.target.value)
                                  }
                                  bsSize="sm"
                                />
                              </div>
                              <div
                                className="price"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <span className="price-label">
                                  ราคาต่อชิ้น (บาท)
                                </span>
                                <Input
                                  type="number"
                                  min="0"
                                  value={
                                    it.price === "" ? "" : Number(it.price)
                                  }
                                  onChange={(e) =>
                                    updateCustomPrice(it.id, e.target.value)
                                  }
                                  bsSize="sm"
                                  className="price-input"
                                  style={{ width: 100 }}
                                />
                                <span className="currency">฿</span>
                              </div>
                              <div
                                className="price"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <span className="price-label">
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </span>
                                <Input
                                  type="number"
                                  min="0"
                                  step="0.01" // ✅ สำคัญ — เปิดให้ใส่ทศนิยม
                                  value={
                                    it.weight === "" ? "" : Number(it.weight)
                                  }
                                  onChange={(e) =>
                                    updateCustomWeight(it.id, e.target.value)
                                  }
                                  bsSize="sm"
                                  className="price-input"
                                  style={{ width: 100 }}
                                />
                              </div>
                              <div className="qty">
                                <span className="unit">จำนวนผ้า</span>
                                <Button
                                  color="light"
                                  onClick={() => decCustomQty(it.id)}
                                  className="btn-qty"
                                >
                                  –
                                </Button>
                                <Input
                                  type="number"
                                  min="0"
                                  value={it.qty === "" ? "" : Number(it.qty)}
                                  onChange={(e) =>
                                    updateCustomQty(it.id, e.target.value)
                                  }
                                  className="qty-input"
                                />
                                <Button
                                  onClick={() => incCustomQty(it.id)}
                                  className="btn-qty"
                                  style={{
                                    backgroundColor: "#1171ef",
                                    color: "#fff",
                                    border: "none",
                                  }}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          ))}
                          <AddDetailFab onClick={addCustomItem} />
                        </>
                      )}

                      {/* ================= Package list (แท็บซื้อแพ็คเกจ) ================= */}
                      {activeTab === "package" && (
                        <>
                          {!spLoading && spError && (
                            <div className="text-center text-danger py-3">
                              {spError}
                            </div>
                          )}
                          {!spLoading &&
                            !spError &&
                            servicePkgs.length === 0 && (
                              <div className="text-center text-muted py-3">
                                ยังไม่มีแพ็คเกจ
                              </div>
                            )}

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "repeat(auto-fit, minmax(260px, 1fr))",
                              gap: 16,
                            }}
                            className="package-grid"
                          >
                            {servicePkgs.map((p) => (
                              <Card
                                key={p.id}
                                onClick={() => addPkgToCart(p)}
                                role="button"
                                tabIndex={0}
                                style={{
                                  borderRadius: 14,
                                  backgroundColor: "#0ea5e9",
                                  color: "#fff",
                                  cursor: "pointer",
                                  transition:
                                    "transform .08s ease, box-shadow .2s ease, background-color .2s ease",
                                  boxShadow:
                                    "0 4px 10px rgba(17, 113, 239, 0.3)",
                                }}
                                onMouseDown={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(0.98)";
                                }}
                                onMouseUp={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                }}
                              >
                                <CardBody style={{ padding: "16px 18px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          fontSize: 16,
                                        }}
                                      >
                                        {p.name}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: 12,
                                          opacity: 0.9,
                                          marginTop: 4,
                                        }}
                                      >
                                        {p.unit ? `(${p.qty} ${p.unit})` : ""} •{" "}
                                        {p.type}
                                      </div>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                      <div style={{ fontWeight: 700 }}>
                                        {p.price.toLocaleString()} ฿
                                      </div>
                                      {p.leadtime ? (
                                        <div
                                          style={{ fontSize: 12, opacity: 0.9 }}
                                        >
                                          {p.leadtime} วัน
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            ))}
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                {/* Right: Cart */}
                {laundryMode === "perItem" ? (
                  <Col xs="12" md="12" lg={4} className="px-0 px-lg-2">
                    {activeTab === "laundry" ? (
                      <Card className="shadow-sm">
                        <div
                          className="position-sticky cart-sticky"
                          style={{ top: 72, width: "100%" }}
                        >
                          <CardBody>
                            <h5 className="mb-3">ตะกร้า (เปิดบิล)</h5>
                            {activeTab === "laundry" &&
                              selectedCustomerLaundry && (
                                <>
                                  <div
                                    className="mb-2"
                                    style={{ fontSize: 12, color: "#475569" }}
                                  >
                                    ลูกค้าที่เลือก:{" "}
                                    <strong>
                                      {selectedCustomerLaundry.code} -{" "}
                                      {selectedCustomerLaundry.name}
                                    </strong>
                                  </div>

                                  {selectedServiceFromAPI && (
                                    <div
                                      className="mb-2 p-2"
                                      style={{
                                        fontSize: 12,
                                        color: "#475569",
                                        background: "#f8fafc",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: 12,
                                      }}
                                    >
                                      <div>
                                        บริการที่เลือก:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {selectedServiceFromAPI.name}
                                        </strong>
                                      </div>

                                      <div style={{ marginTop: 2 }}>
                                        ประเภท:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {selectedServiceFromAPI.type || "-"}
                                        </strong>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}

                            <ListGroup className="mb-3">
                              {cartLaundry.length === 0 && (
                                <ListGroupItem className="text-center text-muted">
                                  ยังไม่มีรายการ
                                </ListGroupItem>
                              )}
                              {cartLaundry.map((p) => (
                                <ListGroupItem
                                  key={p.id}
                                  className="d-flex align-items-center justify-content-between mb-2"
                                  style={{
                                    borderRadius: 12,
                                    border: "1px solid #f1f1f1",
                                  }}
                                >
                                  <div style={{ fontWeight: 700 }}>
                                    {p.name}
                                  </div>

                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: 10 }}
                                  >
                                    <div
                                      style={{
                                        whiteSpace: "nowrap",
                                        color: "#64748b",
                                      }}
                                    >
                                      {p.qty} × {p.price.toLocaleString()} ฿
                                    </div>
                                    <Button
                                      color="link"
                                      onClick={() => removeLaundryItem(p)}
                                      title="ลบรายการ"
                                      style={{ padding: 0, lineHeight: 0 }}
                                      aria-label="ลบรายการ"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ color: "#e11d48" }}
                                      >
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                        <path d="M10 11v6"></path>
                                        <path d="M14 11v6"></path>
                                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                                      </svg>
                                    </Button>
                                  </div>
                                </ListGroupItem>
                              ))}
                            </ListGroup>

                            <div
                              className="p-2 rounded mb-3"
                              style={{
                                background: "#f1f5ff",
                                border: "1px dashed #bcd1ff",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <span>ยอดรวม</span>
                                <strong>
                                  {totalLaundry.toLocaleString()} บาท
                                </strong>
                              </div>
                            </div>

                            <Button
                              block
                              style={{
                                height: 48,
                                fontWeight: 700,
                                backgroundColor: "#1171ef",
                                color: "#fff",
                                border: "none",
                              }}
                              onClick={openBillModal}
                            >
                              เปิดบิล
                            </Button>
                          </CardBody>
                        </div>
                      </Card>
                    ) : (
                      <Card className="shadow-sm">
                        <div
                          className="position-sticky cart-sticky"
                          style={{ top: 72, width: "100%" }}
                        >
                          <CardBody>
                            <h5 className="mb-3">ตะกร้าแพ็คเกจ</h5>
                            {activeTab === "package" &&
                              selectedCustomerPackage && (
                                <div
                                  className="mb-2"
                                  style={{ fontSize: 12, color: "#475569" }}
                                >
                                  ลูกค้าที่เลือก:{" "}
                                  <strong>
                                    {selectedCustomerPackage.code} -{" "}
                                    {selectedCustomerPackage.name}
                                  </strong>
                                </div>
                              )}
                            <ListGroup className="mb-3">
                              {cartPackage.length === 0 && (
                                <ListGroupItem className="text-center text-muted">
                                  ยังไม่มีแพ็คเกจ
                                </ListGroupItem>
                              )}
                              {cartPackage.map((p) => (
                                <ListGroupItem
                                  key={p.id}
                                  className="mb-2"
                                  style={{
                                    borderRadius: 12,
                                    border: "1px solid #f1f1f1",
                                    padding: "0.9rem 1rem",
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <div style={{ fontWeight: 700 }}>
                                        {p.name}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: 12,
                                          color: "#6b7280",
                                        }}
                                      >
                                        จำนวนซื้อ {p.qty} ชุด
                                      </div>
                                    </div>

                                    <div
                                      className="d-flex align-items-center"
                                      style={{ gap: 10 }}
                                    >
                                      <div
                                        style={{
                                          textAlign: "right",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {p.price.toLocaleString()} ฿ / ชุด
                                      </div>
                                      <Button
                                        color="link"
                                        onClick={() => removePackageItem(p.id)}
                                        title="ลบแพ็คเกจนี้"
                                        style={{ padding: 0, lineHeight: 0 }}
                                        aria-label="ลบแพ็คเกจนี้"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          style={{ color: "#e11d48" }}
                                        >
                                          <polyline points="3 6 5 6 21 6"></polyline>
                                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                          <path d="M10 11v6"></path>
                                          <path d="M14 11v6"></path>
                                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                                        </svg>
                                      </Button>
                                    </div>
                                  </div>
                                </ListGroupItem>
                              ))}
                            </ListGroup>

                            <div
                              className="p-2 rounded mb-3"
                              style={{
                                background: "#f1f5ff",
                                border: "1px dashed #bcd1ff",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <span>ยอดรวม</span>
                                <strong>
                                  {totalPackage.toLocaleString()} บาท
                                </strong>
                              </div>
                            </div>

                            <Button
                              block
                              onClick={handlePayPackages}
                              disabled={paying || cartPackage.length === 0}
                              style={{
                                height: 48,
                                fontWeight: 700,
                                backgroundColor: "#1171ef",
                                color: "#fff",
                                border: "none",
                              }}
                            >
                              {paying ? (
                                <span className="spinner-border spinner-border-sm" />
                              ) : (
                                "ชำระเงิน"
                              )}
                            </Button>
                          </CardBody>
                        </div>
                      </Card>
                    )}
                  </Col>
                ) : (
                  <Col xs="12" md="12" lg={4} className="px-0 px-lg-2">
                    {activeTab === "laundry" ? (
                      <Card className="shadow-sm">
                        <div
                          className="position-sticky cart-sticky"
                          style={{ top: 72, width: "100%" }}
                        >
                          <CardBody>
                            <h5 className="mb-3">ตะกร้า (เปิดบิล)</h5>
                            {activeTab === "laundry" &&
                              selectedCustomerLaundry && (
                                <>
                                  <div
                                    className="mb-2"
                                    style={{ fontSize: 12, color: "#475569" }}
                                  >
                                    ลูกค้าที่เลือก:{" "}
                                    <strong>
                                      {selectedCustomerLaundry.code} -{" "}
                                      {selectedCustomerLaundry.name}
                                    </strong>
                                  </div>

                                  {selectedServiceFromAPI && (
                                    <div
                                      className="mb-2 p-2"
                                      style={{
                                        fontSize: 12,
                                        color: "#475569",
                                        background: "#f8fafc",
                                        border: "1px solid #e2e8f0",
                                        borderRadius: 12,
                                      }}
                                    >
                                      <div>
                                        บริการที่เลือก:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {selectedServiceFromAPI.name}
                                        </strong>
                                      </div>

                                      <div style={{ marginTop: 2 }}>
                                        ประเภท:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {selectedServiceFromAPI.type || "-"}
                                        </strong>
                                      </div>

                                      <div style={{ marginTop: 2 }}>
                                        ราคาบริการ:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {Number(
                                            selectedServiceFromAPI.svPrice || 0,
                                          ).toLocaleString()}
                                        </strong>{" "}
                                        ฿
                                      </div>

                                      <div style={{ marginTop: 2 }}>
                                        จำนวนผ้าสูงสุด:{" "}
                                        <strong style={{ color: "#0f172a" }}>
                                          {Number(
                                            selectedServiceFromAPI.svQty || 0,
                                          )}
                                        </strong>{" "}
                                        {selectedServiceFromAPI.svUnit || "-"}
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}

                            <ListGroup className="mb-3">
                              {cartLaundry.length === 0 && (
                                <ListGroupItem className="text-center text-muted">
                                  ยังไม่มีรายการ
                                </ListGroupItem>
                              )}
                              {cartLaundry.map((p) => (
                                <ListGroupItem
                                  key={p.id}
                                  className="d-flex align-items-center justify-content-between mb-2"
                                  style={{
                                    borderRadius: 12,
                                    border: "1px solid #f1f1f1",
                                  }}
                                >
                                  <div style={{ fontWeight: 700 }}>
                                    {p.name}
                                  </div>

                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: 10 }}
                                  >
                                    <div
                                      style={{
                                        whiteSpace: "nowrap",
                                        color: "#64748b",
                                      }}
                                    >
                                      {p.qty}
                                    </div>
                                    <Button
                                      color="link"
                                      onClick={() => removeLaundryItem(p)}
                                      title="ลบรายการ"
                                      style={{ padding: 0, lineHeight: 0 }}
                                      aria-label="ลบรายการ"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ color: "#e11d48" }}
                                      >
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                        <path d="M10 11v6"></path>
                                        <path d="M14 11v6"></path>
                                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                                      </svg>
                                    </Button>
                                  </div>
                                </ListGroupItem>
                              ))}
                            </ListGroup>

                            <div
                              className="p-2 rounded mb-3"
                              style={{
                                background: "#f1f5ff",
                                border: "1px dashed #bcd1ff",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <span>น้ำหนักผ้ารวม</span>
                                <strong>
                                  {Number(totalPdWeight || 0).toFixed(2)}{" "}
                                  (กิโลกรัม)
                                </strong>
                              </div>
                            </div>
                            {selectedServiceFromAPI && (
                              <div
                                className="p-2 rounded mb-3"
                                style={{
                                  background: "#f1f5ff",
                                  border: "1px dashed #bcd1ff",
                                }}
                              >
                                <div className="d-flex justify-content-between">
                                  <span>ยอดรวม</span>
                                  <strong>
                                    {(
                                      selectedServiceFromAPI.svPrice || 0
                                    ).toLocaleString()}{" "}
                                    บาท
                                  </strong>
                                </div>
                              </div>
                            )}

                            <Button
                              block
                              style={{
                                height: 48,
                                fontWeight: 700,
                                backgroundColor: "#1171ef",
                                color: "#fff",
                                border: "none",
                              }}
                              onClick={openBillModal}
                            >
                              เปิดบิล
                            </Button>
                          </CardBody>
                        </div>
                      </Card>
                    ) : (
                      <Card className="shadow-sm">
                        <div
                          className="position-sticky cart-sticky"
                          style={{ top: 72, width: "100%" }}
                        >
                          <CardBody>
                            <h5 className="mb-3">ตะกร้าแพ็คเกจ</h5>
                            {activeTab === "package" &&
                              selectedCustomerPackage && (
                                <div
                                  className="mb-2"
                                  style={{ fontSize: 12, color: "#475569" }}
                                >
                                  ลูกค้าที่เลือก:{" "}
                                  <strong>
                                    {selectedCustomerPackage.code} -{" "}
                                    {selectedCustomerPackage.name}
                                  </strong>
                                </div>
                              )}
                            <ListGroup className="mb-3">
                              {cartPackage.length === 0 && (
                                <ListGroupItem className="text-center text-muted">
                                  ยังไม่มีแพ็คเกจ
                                </ListGroupItem>
                              )}
                              {cartPackage.map((p) => (
                                <ListGroupItem
                                  key={p.id}
                                  className="mb-2"
                                  style={{
                                    borderRadius: 12,
                                    border: "1px solid #f1f1f1",
                                    padding: "0.9rem 1rem",
                                  }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <div style={{ fontWeight: 700 }}>
                                        {p.name}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: 12,
                                          color: "#6b7280",
                                        }}
                                      >
                                        จำนวนซื้อ {p.qty} ชุด
                                      </div>
                                    </div>

                                    <div
                                      className="d-flex align-items-center"
                                      style={{ gap: 10 }}
                                    >
                                      <div
                                        style={{
                                          textAlign: "right",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {p.price.toLocaleString()} ฿ / ชุด
                                      </div>
                                      <Button
                                        color="link"
                                        onClick={() => removePackageItem(p.id)}
                                        title="ลบแพ็คเกจนี้"
                                        style={{ padding: 0, lineHeight: 0 }}
                                        aria-label="ลบแพ็คเกจนี้"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          style={{ color: "#e11d48" }}
                                        >
                                          <polyline points="3 6 5 6 21 6"></polyline>
                                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                          <path d="M10 11v6"></path>
                                          <path d="M14 11v6"></path>
                                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                                        </svg>
                                      </Button>
                                    </div>
                                  </div>
                                </ListGroupItem>
                              ))}
                            </ListGroup>

                            <div
                              className="p-2 rounded mb-3"
                              style={{
                                background: "#f1f5ff",
                                border: "1px dashed #bcd1ff",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <span>ยอดรวม</span>
                                <strong>
                                  {totalPackage.toLocaleString()} บาท
                                </strong>
                              </div>
                            </div>

                            <Button
                              block
                              onClick={handlePayPackages}
                              disabled={paying || cartPackage.length === 0}
                              style={{
                                height: 48,
                                fontWeight: 700,
                                backgroundColor: "#1171ef",
                                color: "#fff",
                                border: "none",
                              }}
                            >
                              {paying ? (
                                <span className="spinner-border spinner-border-sm" />
                              ) : (
                                "ชำระเงิน"
                              )}
                            </Button>
                          </CardBody>
                        </div>
                      </Card>
                    )}
                  </Col>
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>

        {/* Modal: แพ็คเกจของลูกค้า */}
        <Modal
          isOpen={isPkgModalOpen}
          toggle={togglePkgModal}
          size="lg"
          centered
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader toggle={togglePkgModal}>
            แพ็คเกจลูกค้า
            {selectedCustomerLaundry ? `: ${selectedCustomerLaundry.name}` : ""}
          </ModalHeader>

          <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
            {(() => {
              const subs = (selectedCustomerLaundry?.subscriptions || [])
                .map((s) => ({
                  stId: s.stId,
                  svId: s.svId,
                  name: s.svName || "-",
                  amount: Number(s.amount || 0),
                  used: Number(s.used || 0),
                  remaining: Number(s.remaining || 0),
                  startDate: s.startDate,
                  endDate: s.endDate,
                  status: s.status, // 'Y' = ใช้งานได้
                  products: s.products || [],
                }))
                .sort((a, b) => b.remaining - a.remaining);

              if (subs.length === 0) {
                return (
                  <div className="text-center text-muted py-3">
                    ลูกค้ายังไม่มีแพ็คเกจ
                  </div>
                );
              }

              return (
                <Row>
                  <Col xs="12">
                    <div className="subs-grid">
                      {subs.map((pkg) => {
                        const isActive = pkg.status === "Y";
                        const isOut = pkg.remaining <= 0;
                        const isClickable = isActive && !isOut;
                        return (
                          <Button
                            key={`${pkg.stId}-${pkg.svId}`}
                            disabled={!isClickable}
                            onClick={() => {
                              setSelectedCustomerPackageInfo(pkg);

                              // ✅ เลือกแพ็คเกจแล้ว แต่ “สินค้า” ให้โชว์ของลูกค้า
                              setAllowCustomerProducts(true);

                              const nextMode =
                                resolveModeForService(pkg.svId) || "perItem";
                              setLaundryMode(nextMode);

                              // ล็อกไม่ให้เปลี่ยน service/tab ย่อย (แต่ยังเปิด modal เปลี่ยนได้)
                              setLockServiceUI(true);

                              // ✅ ให้ selectedServiceId ชี้ไปที่ svId ของแพ็คเกจ (ใช้ตอนเปิดบิล)
                              setSelectedServiceId(pkg.svId);

                              setIsPkgModalOpen(false);
                            }}
                            className={`w-100 subs-card ${
                              isClickable ? "subs-active" : "subs-disabled"
                            }`}
                          >
                            <span style={{ fontSize: 15, marginBottom: 4 }}>
                              {pkg.name}
                            </span>
                            <span style={{ fontSize: 12 }}>
                              คงเหลือ {pkg.remaining} / {pkg.amount} ครั้ง
                            </span>
                            {pkg.endDate && (
                              <span style={{ fontSize: 11 }}>
                                หมดอายุ:{" "}
                                {new Date(pkg.endDate).toLocaleDateString()}
                              </span>
                            )}
                          </Button>
                        );
                      })}
                    </div>
                  </Col>
                </Row>
              );
            })()}
          </ModalBody>
        </Modal>

        {/* Modal: เพิ่มลูกค้า */}
        <Modal
          isOpen={isAddModalOpen}
          toggle={toggleAddModal}
          size="lg"
          centered
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader toggle={toggleAddModal}>เพิ่มลูกค้า</ModalHeader>
          <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
            <Form onSubmit={handleAddCustomerSubmit}>
              <div className="pl-lg-4">
                <Row className="mb-3">
                  <Col lg="12">
                    <div style={{ display: "flex", gap: 8 }}>
                      <Button
                        size="sm"
                        color={
                          customerType === "individual"
                            ? "primary"
                            : "secondary"
                        }
                        outline={customerType !== "individual"}
                        className="rounded-pill"
                        type="button"
                        onClick={() => setCustomerType("individual")}
                      >
                        บุคคลธรรมดา
                      </Button>
                      <Button
                        size="sm"
                        color={
                          customerType === "juristic" ? "primary" : "secondary"
                        }
                        outline={customerType !== "juristic"}
                        className="rounded-pill"
                        type="button"
                        onClick={() => setCustomerType("juristic")}
                      >
                        นิติบุคคล
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    <FormGroup>
                      <label className="form-control-label required">
                        {isCompany ? "ชื่อบริษัท / นิติบุคคล" : "ชื่อลูกค้า"}
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        name="cmName"
                        value={customerForm.cmName}
                        onChange={handleChangeCustomerForm}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6">
                    <FormGroup>
                      <label className="form-control-label required">
                        เบอร์โทร
                      </label>
                      <Input
                        className="form-control-alternative"
                        type="text"
                        name="cmMobile"
                        value={customerForm.cmMobile}
                        onChange={handleChangeCustomerForm}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className="text-right mt-4">
                <Button
                  color="primary"
                  type="submit"
                  style={{ minWidth: 120 }}
                  disabled={submittingCustomer}
                >
                  {submittingCustomer ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "บันทึก"
                  )}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        {/* Modal: เปิดบิล - เลือกวันที่รับ/ส่งผ้า */}
        <Modal
          isOpen={isBillModalOpen}
          toggle={() => {
            if (!creatingBill) setIsBillModalOpen(false);
          }}
          centered
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader
            toggle={creatingBill ? undefined : () => setIsBillModalOpen(false)}
          >
            กำหนดวันที่รับผ้า / วันที่ส่งผ้า
          </ModalHeader>
          <ModalBody style={{ width: "100%", padding: "1.5rem" }}>
            <Form>
              <FormGroup>
                <label className="form-control-label">วันที่รับผ้า</label>
                <Input
                  type="date"
                  value={receiveDate}
                  onChange={(e) => setReceiveDate(e.target.value)}
                />
              </FormGroup>
              <FormGroup>
                <label className="form-control-label">วันที่ส่งผ้า</label>
                <Input
                  type="date"
                  value={dueDate}
                  onChange={(e) => setDueDate(e.target.value)}
                />
              </FormGroup>

              <div className="text-right mt-4">
                <Button
                  color="secondary"
                  className="mr-2"
                  onClick={() => setIsBillModalOpen(false)}
                  disabled={creatingBill}
                >
                  ยกเลิก
                </Button>
                <Button
                  color="primary"
                  onClick={handleSaveBill}
                  disabled={creatingBill}
                  style={{ minWidth: 120 }}
                >
                  {creatingBill ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "บันทึก"
                  )}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default Order;
